// Pokédex complet (Gen 1-9) généré depuis zeroxm/pokemon-roulette.
// Ne pas éditer à la main — régénérer via `npm run generate:pokedex`.
// Source : https://raw.githubusercontent.com/zeroxm/pokemon-roulette/main/src/app/services/pokemon-service/national-dex-pokemon.ts
//          https://raw.githubusercontent.com/zeroxm/pokemon-roulette/main/src/assets/i18n/fr.json

import type { PokedexEntry } from "../types/battle.js";

export const POKEDEX: readonly PokedexEntry[] = [
  { id: 1, nameFr: "Bulbizarre", type1: "grass", type2: "poison", power: 1 },
  { id: 2, nameFr: "Herbizarre", type1: "grass", type2: "poison", power: 2 },
  { id: 3, nameFr: "Florizarre", type1: "grass", type2: "poison", power: 3 },
  { id: 4, nameFr: "Salamèche", type1: "fire", power: 1 },
  { id: 5, nameFr: "Reptincel", type1: "fire", power: 2 },
  { id: 6, nameFr: "Dracaufeu", type1: "fire", type2: "flying", power: 3 },
  { id: 7, nameFr: "Carapuce", type1: "water", power: 1 },
  { id: 8, nameFr: "Carabaffe", type1: "water", power: 2 },
  { id: 9, nameFr: "Tortank", type1: "water", power: 3 },
  { id: 10, nameFr: "Chenipan", type1: "bug", power: 1 },
  { id: 11, nameFr: "Chrysacier", type1: "bug", power: 1 },
  { id: 12, nameFr: "Papilusion", type1: "bug", type2: "flying", power: 2 },
  { id: 13, nameFr: "Aspicot", type1: "bug", type2: "poison", power: 1 },
  { id: 14, nameFr: "Coconfort", type1: "bug", type2: "poison", power: 1 },
  { id: 15, nameFr: "Dardargnan", type1: "bug", type2: "poison", power: 2 },
  { id: 16, nameFr: "Roucool", type1: "normal", type2: "flying", power: 1 },
  { id: 17, nameFr: "Roucoups", type1: "normal", type2: "flying", power: 2 },
  { id: 18, nameFr: "Roucarnage", type1: "normal", type2: "flying", power: 3 },
  { id: 19, nameFr: "Rattata", type1: "normal", power: 1 },
  { id: 20, nameFr: "Rattatac", type1: "normal", power: 2 },
  { id: 21, nameFr: "Piafabec", type1: "normal", type2: "flying", power: 1 },
  { id: 22, nameFr: "Rapasdepic", type1: "normal", type2: "flying", power: 2 },
  { id: 23, nameFr: "Abo", type1: "poison", power: 1 },
  { id: 24, nameFr: "Arbok", type1: "poison", power: 2 },
  { id: 25, nameFr: "Pikachu", type1: "electric", power: 2 },
  { id: 26, nameFr: "Raichu", type1: "electric", power: 3 },
  { id: 27, nameFr: "Sabelette", type1: "ground", power: 1 },
  { id: 28, nameFr: "Sablaireau", type1: "ground", power: 2 },
  { id: 29, nameFr: "Nidoran♀", type1: "poison", power: 1 },
  { id: 30, nameFr: "Nidorina", type1: "poison", power: 2 },
  { id: 31, nameFr: "Nidoqueen", type1: "poison", type2: "ground", power: 3 },
  { id: 32, nameFr: "Nidoran♂", type1: "poison", power: 1 },
  { id: 33, nameFr: "Nidorino", type1: "poison", power: 2 },
  { id: 34, nameFr: "Nidoking", type1: "poison", type2: "ground", power: 3 },
  { id: 35, nameFr: "Mélofée", type1: "fairy", power: 2 },
  { id: 36, nameFr: "Mélodelfe", type1: "fairy", power: 3 },
  { id: 37, nameFr: "Goupix", type1: "fire", power: 1 },
  { id: 38, nameFr: "Feunard", type1: "fire", power: 3 },
  { id: 39, nameFr: "Rondoudou", type1: "normal", type2: "fairy", power: 1 },
  { id: 40, nameFr: "Grodoudou", type1: "normal", type2: "fairy", power: 2 },
  { id: 41, nameFr: "Nosferapti", type1: "poison", type2: "flying", power: 1 },
  { id: 42, nameFr: "Nosferalto", type1: "poison", type2: "flying", power: 2 },
  { id: 43, nameFr: "Mystherbe", type1: "grass", type2: "poison", power: 1 },
  { id: 44, nameFr: "Ortide", type1: "grass", type2: "poison", power: 2 },
  { id: 45, nameFr: "Rafflesia", type1: "grass", type2: "poison", power: 3 },
  { id: 46, nameFr: "Paras", type1: "bug", type2: "grass", power: 1 },
  { id: 47, nameFr: "Parasect", type1: "bug", type2: "grass", power: 2 },
  { id: 48, nameFr: "Mimitoss", type1: "bug", type2: "poison", power: 1 },
  { id: 49, nameFr: "Aéromite", type1: "bug", type2: "poison", power: 2 },
  { id: 50, nameFr: "Taupiqueur", type1: "ground", power: 1 },
  { id: 51, nameFr: "Triopikeur", type1: "ground", power: 2 },
  { id: 52, nameFr: "Miaouss", type1: "normal", power: 1 },
  { id: 53, nameFr: "Persian", type1: "normal", power: 2 },
  { id: 54, nameFr: "Psykokwak", type1: "water", power: 1 },
  { id: 55, nameFr: "Akwakwak", type1: "water", power: 3 },
  { id: 56, nameFr: "Férosinge", type1: "fighting", power: 1 },
  { id: 57, nameFr: "Colossinge", type1: "fighting", power: 2 },
  { id: 58, nameFr: "Caninos", type1: "fire", power: 1 },
  { id: 59, nameFr: "Arcanin", type1: "fire", power: 3 },
  { id: 60, nameFr: "Ptitard", type1: "water", power: 1 },
  { id: 61, nameFr: "Têtarte", type1: "water", power: 2 },
  { id: 62, nameFr: "Tartard", type1: "water", type2: "fighting", power: 3 },
  { id: 63, nameFr: "Abra", type1: "psychic", power: 1 },
  { id: 64, nameFr: "Kadabra", type1: "psychic", power: 2 },
  { id: 65, nameFr: "Alakazam", type1: "psychic", power: 3 },
  { id: 66, nameFr: "Machoc", type1: "fighting", power: 1 },
  { id: 67, nameFr: "Machopeur", type1: "fighting", power: 2 },
  { id: 68, nameFr: "Mackogneur", type1: "fighting", power: 3 },
  { id: 69, nameFr: "Chétiflor", type1: "grass", type2: "poison", power: 1 },
  { id: 70, nameFr: "Boustiflor", type1: "grass", type2: "poison", power: 2 },
  { id: 71, nameFr: "Empiflor", type1: "grass", type2: "poison", power: 3 },
  { id: 72, nameFr: "Tentacool", type1: "water", type2: "poison", power: 1 },
  { id: 73, nameFr: "Tentacruel", type1: "water", type2: "poison", power: 3 },
  { id: 74, nameFr: "Racaillou", type1: "rock", type2: "ground", power: 1 },
  { id: 75, nameFr: "Gravalanch", type1: "rock", type2: "ground", power: 2 },
  { id: 76, nameFr: "Grolem", type1: "rock", type2: "ground", power: 3 },
  { id: 77, nameFr: "Ponyta", type1: "fire", power: 2 },
  { id: 78, nameFr: "Galopa", type1: "fire", power: 3 },
  { id: 79, nameFr: "Ramoloss", type1: "water", type2: "psychic", power: 1 },
  { id: 80, nameFr: "Flagadoss", type1: "water", type2: "psychic", power: 3 },
  { id: 81, nameFr: "Magnéti", type1: "electric", type2: "steel", power: 1 },
  { id: 82, nameFr: "Magnéton", type1: "electric", type2: "steel", power: 2 },
  { id: 83, nameFr: "Canarticho", type1: "normal", type2: "flying", power: 2 },
  { id: 84, nameFr: "Doduo", type1: "normal", type2: "flying", power: 1 },
  { id: 85, nameFr: "Dodrio", type1: "normal", type2: "flying", power: 2 },
  { id: 86, nameFr: "Otaria", type1: "water", power: 1 },
  { id: 87, nameFr: "Lamantine", type1: "water", type2: "ice", power: 2 },
  { id: 88, nameFr: "Tadmorv", type1: "poison", power: 1 },
  { id: 89, nameFr: "Grotadmorv", type1: "poison", power: 3 },
  { id: 90, nameFr: "Kokiyas", type1: "water", power: 1 },
  { id: 91, nameFr: "Crustabri", type1: "water", type2: "ice", power: 3 },
  { id: 92, nameFr: "Fantominus", type1: "ghost", type2: "poison", power: 1 },
  { id: 93, nameFr: "Spectrum", type1: "ghost", type2: "poison", power: 2 },
  { id: 94, nameFr: "Ectoplasma", type1: "ghost", type2: "poison", power: 3 },
  { id: 95, nameFr: "Onix", type1: "rock", type2: "ground", power: 2 },
  { id: 96, nameFr: "Soporifik", type1: "psychic", power: 1 },
  { id: 97, nameFr: "Hypnomade", type1: "psychic", power: 2 },
  { id: 98, nameFr: "Krabby", type1: "water", power: 1 },
  { id: 99, nameFr: "Krabboss", type1: "water", power: 2 },
  { id: 100, nameFr: "Voltorbe", type1: "electric", power: 1 },
  { id: 101, nameFr: "Électrode", type1: "electric", power: 3 },
  { id: 102, nameFr: "Noeunoeuf", type1: "grass", type2: "psychic", power: 1 },
  { id: 103, nameFr: "Noadkoko", type1: "grass", type2: "psychic", power: 3 },
  { id: 104, nameFr: "Osselait", type1: "ground", power: 1 },
  { id: 105, nameFr: "Ossatueur", type1: "ground", power: 2 },
  { id: 106, nameFr: "Kicklee", type1: "fighting", power: 2 },
  { id: 107, nameFr: "Tygnon", type1: "fighting", power: 2 },
  { id: 108, nameFr: "Excelangue", type1: "normal", power: 2 },
  { id: 109, nameFr: "Smogo", type1: "poison", power: 1 },
  { id: 110, nameFr: "Smogogo", type1: "poison", power: 3 },
  { id: 111, nameFr: "Rhinocorne", type1: "ground", type2: "rock", power: 1 },
  { id: 112, nameFr: "Rhinoféros", type1: "ground", type2: "rock", power: 2 },
  { id: 113, nameFr: "Leveinard", type1: "normal", power: 2 },
  { id: 114, nameFr: "Saquedeneu", type1: "grass", power: 2 },
  { id: 115, nameFr: "Kangourex", type1: "normal", power: 3 },
  { id: 116, nameFr: "Hypotrempe", type1: "water", power: 1 },
  { id: 117, nameFr: "Hypocéan", type1: "water", power: 2 },
  { id: 118, nameFr: "Poissirène", type1: "water", power: 1 },
  { id: 119, nameFr: "Poissoroy", type1: "water", power: 2 },
  { id: 120, nameFr: "Stari", type1: "water", power: 1 },
  { id: 121, nameFr: "Staross", type1: "water", type2: "psychic", power: 3 },
  { id: 122, nameFr: "M. Mime", type1: "psychic", type2: "fairy", power: 2 },
  { id: 123, nameFr: "Insécateur", type1: "bug", type2: "flying", power: 3 },
  { id: 124, nameFr: "Lippoutou", type1: "ice", type2: "psychic", power: 2 },
  { id: 125, nameFr: "Élektek", type1: "electric", power: 3 },
  { id: 126, nameFr: "Magmar", type1: "fire", power: 3 },
  { id: 127, nameFr: "Scarabrute", type1: "bug", power: 3 },
  { id: 128, nameFr: "Tauros", type1: "normal", power: 3 },
  { id: 129, nameFr: "Magicarpe", type1: "water", power: 1 },
  { id: 130, nameFr: "Léviator", type1: "water", type2: "flying", power: 3 },
  { id: 131, nameFr: "Lokhlass", type1: "water", type2: "ice", power: 3 },
  { id: 132, nameFr: "Métamorph", type1: "normal", power: 1 },
  { id: 133, nameFr: "Évoli", type1: "normal", power: 2 },
  { id: 134, nameFr: "Aquali", type1: "water", power: 3 },
  { id: 135, nameFr: "Voltali", type1: "electric", power: 3 },
  { id: 136, nameFr: "Pyroli", type1: "fire", power: 3 },
  { id: 137, nameFr: "Porygon", type1: "normal", power: 2 },
  { id: 138, nameFr: "Amonita", type1: "rock", type2: "water", power: 1 },
  { id: 139, nameFr: "Amonistar", type1: "rock", type2: "water", power: 3 },
  { id: 140, nameFr: "Kabuto", type1: "rock", type2: "water", power: 1 },
  { id: 141, nameFr: "Kabutops", type1: "rock", type2: "water", power: 3 },
  { id: 142, nameFr: "Ptéra", type1: "rock", type2: "flying", power: 3 },
  { id: 143, nameFr: "Ronflex", type1: "normal", power: 3 },
  { id: 144, nameFr: "Artikodin", type1: "ice", type2: "flying", power: 5 },
  { id: 145, nameFr: "Électhor", type1: "electric", type2: "flying", power: 5 },
  { id: 146, nameFr: "Sulfura", type1: "fire", type2: "flying", power: 5 },
  { id: 147, nameFr: "Minidraco", type1: "dragon", power: 1 },
  { id: 148, nameFr: "Draco", type1: "dragon", power: 2 },
  { id: 149, nameFr: "Dracolosse", type1: "dragon", type2: "flying", power: 4 },
  { id: 150, nameFr: "Mewtwo", type1: "psychic", power: 5 },
  { id: 151, nameFr: "Mew", type1: "psychic", power: 5 },
  { id: 152, nameFr: "Germignon", type1: "grass", power: 1 },
  { id: 153, nameFr: "Macronium", type1: "grass", power: 2 },
  { id: 154, nameFr: "Méganium", type1: "grass", power: 3 },
  { id: 155, nameFr: "Héricendre", type1: "fire", power: 1 },
  { id: 156, nameFr: "Feurisson", type1: "fire", power: 2 },
  { id: 157, nameFr: "Typhlosion", type1: "fire", power: 3 },
  { id: 158, nameFr: "Kaiminus", type1: "water", power: 1 },
  { id: 159, nameFr: "Crocrodil", type1: "water", power: 2 },
  { id: 160, nameFr: "Aligatueur", type1: "water", power: 3 },
  { id: 161, nameFr: "Fouinette", type1: "normal", power: 1 },
  { id: 162, nameFr: "Fouinar", type1: "normal", power: 2 },
  { id: 163, nameFr: "Hoothoot", type1: "normal", type2: "flying", power: 1 },
  { id: 164, nameFr: "Noarfang", type1: "normal", type2: "flying", power: 2 },
  { id: 165, nameFr: "Coxy", type1: "bug", type2: "flying", power: 1 },
  { id: 166, nameFr: "Coxyclaque", type1: "bug", type2: "flying", power: 2 },
  { id: 167, nameFr: "Mimigal", type1: "bug", type2: "poison", power: 1 },
  { id: 168, nameFr: "Migalos", type1: "bug", type2: "poison", power: 2 },
  { id: 169, nameFr: "Nostenfer", type1: "poison", type2: "flying", power: 3 },
  { id: 170, nameFr: "Loupio", type1: "water", type2: "electric", power: 1 },
  { id: 171, nameFr: "Lanturn", type1: "water", type2: "electric", power: 2 },
  { id: 172, nameFr: "Pichu", type1: "electric", power: 1 },
  { id: 173, nameFr: "Mélo", type1: "fairy", power: 1 },
  { id: 174, nameFr: "Toudoudou", type1: "normal", type2: "fairy", power: 1 },
  { id: 175, nameFr: "Togepi", type1: "fairy", power: 1 },
  { id: 176, nameFr: "Togetic", type1: "fairy", type2: "flying", power: 2 },
  { id: 177, nameFr: "Natu", type1: "psychic", type2: "flying", power: 1 },
  { id: 178, nameFr: "Xatu", type1: "psychic", type2: "flying", power: 2 },
  { id: 179, nameFr: "Wattouat", type1: "electric", power: 1 },
  { id: 180, nameFr: "Lainergie", type1: "electric", power: 2 },
  { id: 181, nameFr: "Pharamp", type1: "electric", power: 3 },
  { id: 182, nameFr: "Joliflor", type1: "grass", power: 3 },
  { id: 183, nameFr: "Marill", type1: "water", type2: "fairy", power: 2 },
  { id: 184, nameFr: "Azumarill", type1: "water", type2: "fairy", power: 3 },
  { id: 185, nameFr: "Simularbre", type1: "rock", power: 2 },
  { id: 186, nameFr: "Tarpaud", type1: "water", power: 3 },
  { id: 187, nameFr: "Granivol", type1: "grass", type2: "flying", power: 1 },
  { id: 188, nameFr: "Floravol", type1: "grass", type2: "flying", power: 2 },
  { id: 189, nameFr: "Cotovol", type1: "grass", type2: "flying", power: 3 },
  { id: 190, nameFr: "Capumain", type1: "normal", power: 1 },
  { id: 191, nameFr: "Tournegrin", type1: "grass", power: 1 },
  { id: 192, nameFr: "Héliatronc", type1: "grass", power: 2 },
  { id: 193, nameFr: "Yanma", type1: "bug", type2: "flying", power: 2 },
  { id: 194, nameFr: "Axoloto", type1: "water", type2: "ground", power: 1 },
  { id: 195, nameFr: "Maraiste", type1: "water", type2: "ground", power: 2 },
  { id: 196, nameFr: "Mentali", type1: "psychic", power: 3 },
  { id: 197, nameFr: "Noctali", type1: "dark", power: 3 },
  { id: 198, nameFr: "Cornèbre", type1: "dark", type2: "flying", power: 2 },
  { id: 199, nameFr: "Roigada", type1: "water", type2: "psychic", power: 3 },
  { id: 200, nameFr: "Feuforêve", type1: "ghost", power: 2 },
  { id: 201, nameFr: "Zarbi", type1: "psychic", power: 1 },
  { id: 202, nameFr: "Qulbutoké", type1: "psychic", power: 2 },
  { id: 203, nameFr: "Girafarig", type1: "normal", type2: "psychic", power: 2 },
  { id: 204, nameFr: "Pomdepik", type1: "bug", power: 1 },
  { id: 205, nameFr: "Foretress", type1: "bug", type2: "steel", power: 2 },
  { id: 206, nameFr: "Insolourdo", type1: "normal", power: 2 },
  { id: 207, nameFr: "Scorplane", type1: "ground", type2: "flying", power: 2 },
  { id: 208, nameFr: "Steelix", type1: "steel", type2: "ground", power: 3 },
  { id: 209, nameFr: "Snubbull", type1: "fairy", power: 1 },
  { id: 210, nameFr: "Granbull", type1: "fairy", power: 2 },
  { id: 211, nameFr: "Qwilfish", type1: "water", type2: "poison", power: 2 },
  { id: 212, nameFr: "Cizayox", type1: "bug", type2: "steel", power: 3 },
  { id: 213, nameFr: "Caratroc", type1: "bug", type2: "rock", power: 3 },
  { id: 214, nameFr: "Scarhino", type1: "bug", type2: "fighting", power: 3 },
  { id: 215, nameFr: "Farfuret", type1: "dark", type2: "ice", power: 2 },
  { id: 216, nameFr: "Teddiursa", type1: "normal", power: 1 },
  { id: 217, nameFr: "Ursaring", type1: "normal", power: 3 },
  { id: 218, nameFr: "Limagma", type1: "fire", power: 1 },
  { id: 219, nameFr: "Volcaropod", type1: "fire", type2: "rock", power: 2 },
  { id: 220, nameFr: "Marcacrin", type1: "ice", type2: "ground", power: 1 },
  { id: 221, nameFr: "Cochignon", type1: "ice", type2: "ground", power: 2 },
  { id: 222, nameFr: "Corayon", type1: "water", type2: "rock", power: 2 },
  { id: 223, nameFr: "Rémoraid", type1: "water", power: 1 },
  { id: 224, nameFr: "Octillery", type1: "water", power: 2 },
  { id: 225, nameFr: "Cadoizo", type1: "ice", type2: "flying", power: 1 },
  { id: 226, nameFr: "Démanta", type1: "water", type2: "flying", power: 3 },
  { id: 227, nameFr: "Airmure", type1: "steel", type2: "flying", power: 2 },
  { id: 228, nameFr: "Malosse", type1: "dark", type2: "fire", power: 1 },
  { id: 229, nameFr: "Démolosse", type1: "dark", type2: "fire", power: 3 },
  { id: 230, nameFr: "Hyporoi", type1: "water", type2: "dragon", power: 3 },
  { id: 231, nameFr: "Phanpy", type1: "ground", power: 1 },
  { id: 232, nameFr: "Donphan", type1: "ground", power: 3 },
  { id: 233, nameFr: "Porygon2", type1: "normal", power: 3 },
  { id: 234, nameFr: "Cerfrousse", type1: "normal", power: 2 },
  { id: 235, nameFr: "Queulorior", type1: "normal", power: 1 },
  { id: 236, nameFr: "Debugant", type1: "fighting", power: 1 },
  { id: 237, nameFr: "Kapoera", type1: "fighting", power: 2 },
  { id: 238, nameFr: "Lippouti", type1: "ice", type2: "psychic", power: 1 },
  { id: 239, nameFr: "Élekid", type1: "electric", power: 1 },
  { id: 240, nameFr: "Magby", type1: "fire", power: 1 },
  { id: 241, nameFr: "Écrémeuh", type1: "normal", power: 3 },
  { id: 242, nameFr: "Leuphorie", type1: "normal", power: 3 },
  { id: 243, nameFr: "Raikou", type1: "electric", power: 5 },
  { id: 244, nameFr: "Entei", type1: "fire", power: 5 },
  { id: 245, nameFr: "Suicune", type1: "water", power: 5 },
  { id: 246, nameFr: "Embrylex", type1: "rock", type2: "ground", power: 1 },
  { id: 247, nameFr: "Ymphect", type1: "rock", type2: "ground", power: 2 },
  { id: 248, nameFr: "Tyranocif", type1: "rock", type2: "dark", power: 4 },
  { id: 249, nameFr: "Lugia", type1: "psychic", type2: "flying", power: 5 },
  { id: 250, nameFr: "Ho-Oh", type1: "fire", type2: "flying", power: 5 },
  { id: 251, nameFr: "Celebi", type1: "psychic", type2: "grass", power: 5 },
  { id: 252, nameFr: "Arcko", type1: "grass", power: 1 },
  { id: 253, nameFr: "Massko", type1: "grass", power: 2 },
  { id: 254, nameFr: "Jungko", type1: "grass", power: 3 },
  { id: 255, nameFr: "Poussifeu", type1: "fire", power: 1 },
  { id: 256, nameFr: "Galifeu", type1: "fire", type2: "fighting", power: 2 },
  { id: 257, nameFr: "Braségali", type1: "fire", type2: "fighting", power: 3 },
  { id: 258, nameFr: "Gobou", type1: "water", power: 1 },
  { id: 259, nameFr: "Flobio", type1: "water", type2: "ground", power: 2 },
  { id: 260, nameFr: "Laggron", type1: "water", type2: "ground", power: 3 },
  { id: 261, nameFr: "Medhyèna", type1: "dark", power: 1 },
  { id: 262, nameFr: "Grahyèna", type1: "dark", power: 2 },
  { id: 263, nameFr: "Zigzaton", type1: "normal", power: 1 },
  { id: 264, nameFr: "Linéon", type1: "normal", power: 2 },
  { id: 265, nameFr: "Chenipotte", type1: "bug", power: 1 },
  { id: 266, nameFr: "Armulys", type1: "bug", power: 1 },
  { id: 267, nameFr: "Charmillon", type1: "bug", type2: "flying", power: 2 },
  { id: 268, nameFr: "Blindalys", type1: "bug", power: 1 },
  { id: 269, nameFr: "Papinox", type1: "bug", type2: "poison", power: 2 },
  { id: 270, nameFr: "Nénupiot", type1: "water", type2: "grass", power: 1 },
  { id: 271, nameFr: "Lombre", type1: "water", type2: "grass", power: 2 },
  { id: 272, nameFr: "Ludicolo", type1: "water", type2: "grass", power: 3 },
  { id: 273, nameFr: "Grainipiot", type1: "grass", power: 1 },
  { id: 274, nameFr: "Pifeuil", type1: "grass", type2: "dark", power: 2 },
  { id: 275, nameFr: "Tengalice", type1: "grass", type2: "dark", power: 3 },
  { id: 276, nameFr: "Nirondelle", type1: "normal", type2: "flying", power: 1 },
  { id: 277, nameFr: "Hélédelle", type1: "normal", type2: "flying", power: 2 },
  { id: 278, nameFr: "Goélise", type1: "water", type2: "flying", power: 1 },
  { id: 279, nameFr: "Bekipan", type1: "water", type2: "flying", power: 2 },
  { id: 280, nameFr: "Tarsal", type1: "psychic", type2: "fairy", power: 1 },
  { id: 281, nameFr: "Kirlia", type1: "psychic", type2: "fairy", power: 2 },
  { id: 282, nameFr: "Gardevoir", type1: "psychic", type2: "fairy", power: 3 },
  { id: 283, nameFr: "Arakdo", type1: "bug", type2: "water", power: 1 },
  { id: 284, nameFr: "Maskadra", type1: "bug", type2: "flying", power: 2 },
  { id: 285, nameFr: "Balignon", type1: "grass", power: 1 },
  { id: 286, nameFr: "Chapignon", type1: "grass", type2: "fighting", power: 2 },
  { id: 287, nameFr: "Parecool", type1: "normal", power: 1 },
  { id: 288, nameFr: "Vigoroth", type1: "normal", power: 2 },
  { id: 289, nameFr: "Monaflèmit", type1: "normal", power: 4 },
  { id: 290, nameFr: "Ningale", type1: "bug", type2: "ground", power: 1 },
  { id: 291, nameFr: "Ninjask", type1: "bug", type2: "flying", power: 2 },
  { id: 292, nameFr: "Munja", type1: "bug", type2: "ghost", power: 1 },
  { id: 293, nameFr: "Chuchmur", type1: "normal", power: 1 },
  { id: 294, nameFr: "Ramboum", type1: "normal", power: 2 },
  { id: 295, nameFr: "Brouhabam", type1: "normal", power: 3 },
  { id: 296, nameFr: "Makuhita", type1: "fighting", power: 1 },
  { id: 297, nameFr: "Hariyama", type1: "fighting", power: 2 },
  { id: 298, nameFr: "Azurill", type1: "normal", type2: "fairy", power: 1 },
  { id: 299, nameFr: "Tarinor", type1: "rock", power: 1 },
  { id: 300, nameFr: "Skitty", type1: "normal", power: 1 },
  { id: 301, nameFr: "Delcatty", type1: "normal", power: 2 },
  { id: 302, nameFr: "Ténéfix", type1: "dark", type2: "ghost", power: 2 },
  { id: 303, nameFr: "Mysdibule", type1: "steel", type2: "fairy", power: 2 },
  { id: 304, nameFr: "Galekid", type1: "steel", type2: "rock", power: 1 },
  { id: 305, nameFr: "Galegon", type1: "steel", type2: "rock", power: 2 },
  { id: 306, nameFr: "Galeking", type1: "steel", type2: "rock", power: 3 },
  { id: 307, nameFr: "Méditikka", type1: "fighting", type2: "psychic", power: 1 },
  { id: 308, nameFr: "Charmina", type1: "fighting", type2: "psychic", power: 2 },
  { id: 309, nameFr: "Dynavolt", type1: "electric", power: 1 },
  { id: 310, nameFr: "Élecsprint", type1: "electric", power: 2 },
  { id: 311, nameFr: "Posipi", type1: "electric", power: 2 },
  { id: 312, nameFr: "Négapi", type1: "electric", power: 2 },
  { id: 313, nameFr: "Muciole", type1: "bug", power: 2 },
  { id: 314, nameFr: "Lumivole", type1: "bug", power: 2 },
  { id: 315, nameFr: "Rosélia", type1: "grass", type2: "poison", power: 2 },
  { id: 316, nameFr: "Gloupti", type1: "poison", power: 1 },
  { id: 317, nameFr: "Avaltout", type1: "poison", power: 2 },
  { id: 318, nameFr: "Carvanha", type1: "water", type2: "dark", power: 1 },
  { id: 319, nameFr: "Sharpedo", type1: "water", type2: "dark", power: 2 },
  { id: 320, nameFr: "Wailmer", type1: "water", power: 2 },
  { id: 321, nameFr: "Wailord", type1: "water", power: 3 },
  { id: 322, nameFr: "Chamallot", type1: "fire", type2: "ground", power: 1 },
  { id: 323, nameFr: "Camérupt", type1: "fire", type2: "ground", power: 2 },
  { id: 324, nameFr: "Chartor", type1: "fire", power: 2 },
  { id: 325, nameFr: "Spoink", type1: "psychic", power: 1 },
  { id: 326, nameFr: "Groret", type1: "psychic", power: 2 },
  { id: 327, nameFr: "Spinda", type1: "normal", power: 1 },
  { id: 328, nameFr: "Kraknoix", type1: "ground", power: 1 },
  { id: 329, nameFr: "Vibraninf", type1: "ground", type2: "dragon", power: 2 },
  { id: 330, nameFr: "Libégon", type1: "ground", type2: "dragon", power: 3 },
  { id: 331, nameFr: "Cacnea", type1: "grass", power: 1 },
  { id: 332, nameFr: "Cacturne", type1: "grass", type2: "dark", power: 2 },
  { id: 333, nameFr: "Tylton", type1: "normal", type2: "flying", power: 1 },
  { id: 334, nameFr: "Altaria", type1: "dragon", type2: "flying", power: 3 },
  { id: 335, nameFr: "Mangriff", type1: "normal", power: 2 },
  { id: 336, nameFr: "Séviper", type1: "poison", power: 2 },
  { id: 337, nameFr: "Séléroc", type1: "rock", type2: "psychic", power: 2 },
  { id: 338, nameFr: "Solaroc", type1: "rock", type2: "psychic", power: 2 },
  { id: 339, nameFr: "Barloche", type1: "water", type2: "ground", power: 1 },
  { id: 340, nameFr: "Barbicha", type1: "water", type2: "ground", power: 2 },
  { id: 341, nameFr: "Écrapince", type1: "water", power: 1 },
  { id: 342, nameFr: "Colhomard", type1: "water", type2: "dark", power: 2 },
  { id: 343, nameFr: "Balbuto", type1: "ground", type2: "psychic", power: 1 },
  { id: 344, nameFr: "Kaorine", type1: "ground", type2: "psychic", power: 3 },
  { id: 345, nameFr: "Lilia", type1: "rock", type2: "grass", power: 1 },
  { id: 346, nameFr: "Vacilys", type1: "rock", type2: "grass", power: 3 },
  { id: 347, nameFr: "Anorith", type1: "rock", type2: "bug", power: 1 },
  { id: 348, nameFr: "Armaldo", type1: "rock", type2: "bug", power: 3 },
  { id: 349, nameFr: "Barpau", type1: "water", power: 1 },
  { id: 350, nameFr: "Milobellus", type1: "water", power: 3 },
  { id: 351, nameFr: "Morphéo", type1: "normal", power: 1 },
  { id: 352, nameFr: "Kecleon", type1: "normal", power: 2 },
  { id: 353, nameFr: "Polichombr", type1: "ghost", power: 1 },
  { id: 354, nameFr: "Branette", type1: "ghost", power: 2 },
  { id: 355, nameFr: "Skelénox", type1: "ghost", power: 1 },
  { id: 356, nameFr: "Téraclope", type1: "ghost", power: 2 },
  { id: 357, nameFr: "Tropius", type1: "grass", type2: "flying", power: 2 },
  { id: 358, nameFr: "Éoko", type1: "psychic", power: 2 },
  { id: 359, nameFr: "Absol", type1: "dark", power: 2 },
  { id: 360, nameFr: "Okéoké", type1: "psychic", power: 1 },
  { id: 361, nameFr: "Stalgamin", type1: "ice", power: 1 },
  { id: 362, nameFr: "Oniglali", type1: "ice", power: 2 },
  { id: 363, nameFr: "Obalie", type1: "ice", type2: "water", power: 1 },
  { id: 364, nameFr: "Phogleur", type1: "ice", type2: "water", power: 2 },
  { id: 365, nameFr: "Kaimorse", type1: "ice", type2: "water", power: 3 },
  { id: 366, nameFr: "Coquiperl", type1: "water", power: 1 },
  { id: 367, nameFr: "Serpang", type1: "water", power: 2 },
  { id: 368, nameFr: "Rosabyss", type1: "water", power: 2 },
  { id: 369, nameFr: "Relicanth", type1: "water", type2: "rock", power: 2 },
  { id: 370, nameFr: "Lovdisc", type1: "water", power: 1 },
  { id: 371, nameFr: "Draby", type1: "dragon", power: 1 },
  { id: 372, nameFr: "Drackhaus", type1: "dragon", power: 2 },
  { id: 373, nameFr: "Drattak", type1: "dragon", type2: "flying", power: 4 },
  { id: 374, nameFr: "Terhal", type1: "steel", type2: "psychic", power: 1 },
  { id: 375, nameFr: "Métang", type1: "steel", type2: "psychic", power: 2 },
  { id: 376, nameFr: "Métalosse", type1: "steel", type2: "psychic", power: 4 },
  { id: 377, nameFr: "Regirock", type1: "rock", power: 5 },
  { id: 378, nameFr: "Regice", type1: "ice", power: 5 },
  { id: 379, nameFr: "Registeel", type1: "steel", power: 5 },
  { id: 380, nameFr: "Latias", type1: "dragon", type2: "psychic", power: 5 },
  { id: 381, nameFr: "Latios", type1: "dragon", type2: "psychic", power: 5 },
  { id: 382, nameFr: "Kyogre", type1: "water", power: 5 },
  { id: 383, nameFr: "Groudon", type1: "ground", power: 5 },
  { id: 384, nameFr: "Rayquaza", type1: "dragon", type2: "flying", power: 5 },
  { id: 385, nameFr: "Jirachi", type1: "steel", type2: "psychic", power: 5 },
  { id: 386, nameFr: "Deoxys", type1: "psychic", power: 5 },
  { id: 387, nameFr: "Tortipouss", type1: "grass", power: 1 },
  { id: 388, nameFr: "Boskara", type1: "grass", power: 2 },
  { id: 389, nameFr: "Torterra", type1: "grass", type2: "ground", power: 3 },
  { id: 390, nameFr: "Ouisticram", type1: "fire", power: 1 },
  { id: 391, nameFr: "Chimpenfeu", type1: "fire", type2: "fighting", power: 2 },
  { id: 392, nameFr: "Simiabraz", type1: "fire", type2: "fighting", power: 3 },
  { id: 393, nameFr: "Tiplouf", type1: "water", power: 1 },
  { id: 394, nameFr: "Prinplouf", type1: "water", power: 2 },
  { id: 395, nameFr: "Pingoléon", type1: "water", type2: "steel", power: 3 },
  { id: 396, nameFr: "Étourmi", type1: "normal", type2: "flying", power: 1 },
  { id: 397, nameFr: "Étourvol", type1: "normal", type2: "flying", power: 2 },
  { id: 398, nameFr: "Étouraptor", type1: "normal", type2: "flying", power: 3 },
  { id: 399, nameFr: "Keunotor", type1: "normal", power: 1 },
  { id: 400, nameFr: "Castorno", type1: "normal", type2: "water", power: 2 },
  { id: 401, nameFr: "Crikzik", type1: "bug", power: 1 },
  { id: 402, nameFr: "Mélokrik", type1: "bug", power: 2 },
  { id: 403, nameFr: "Lixy", type1: "electric", power: 1 },
  { id: 404, nameFr: "Luxio", type1: "electric", power: 2 },
  { id: 405, nameFr: "Luxray", type1: "electric", power: 3 },
  { id: 406, nameFr: "Rozbouton", type1: "grass", type2: "poison", power: 1 },
  { id: 407, nameFr: "Roserade", type1: "grass", type2: "poison", power: 3 },
  { id: 408, nameFr: "Kranidos", type1: "rock", power: 1 },
  { id: 409, nameFr: "Charkos", type1: "rock", power: 3 },
  { id: 410, nameFr: "Dinoclier", type1: "rock", type2: "steel", power: 1 },
  { id: 411, nameFr: "Bastiodon", type1: "rock", type2: "steel", power: 3 },
  { id: 412, nameFr: "Cheniti", type1: "bug", power: 1 },
  { id: 413, nameFr: "Cheniselle", type1: "bug", type2: "grass", power: 2 },
  { id: 414, nameFr: "Papilord", type1: "bug", type2: "flying", power: 2 },
  { id: 415, nameFr: "Apitrini", type1: "bug", type2: "flying", power: 1 },
  { id: 416, nameFr: "Apireine", type1: "bug", type2: "flying", power: 2 },
  { id: 417, nameFr: "Pachirisu", type1: "electric", power: 2 },
  { id: 418, nameFr: "Mustébouée", type1: "water", power: 1 },
  { id: 419, nameFr: "Mustéflott", type1: "water", power: 3 },
  { id: 420, nameFr: "Ceribou", type1: "grass", power: 1 },
  { id: 421, nameFr: "Ceriflor", type1: "grass", power: 2 },
  { id: 422, nameFr: "Sancoki", type1: "water", power: 1 },
  { id: 423, nameFr: "Tritosor", type1: "water", type2: "ground", power: 2 },
  { id: 424, nameFr: "Capidextre", type1: "normal", power: 2 },
  { id: 425, nameFr: "Baudrive", type1: "ghost", type2: "flying", power: 1 },
  { id: 426, nameFr: "Grodrive", type1: "ghost", type2: "flying", power: 3 },
  { id: 427, nameFr: "Laporeille", type1: "normal", power: 1 },
  { id: 428, nameFr: "Lockpin", type1: "normal", power: 2 },
  { id: 429, nameFr: "Magirêve", type1: "ghost", power: 3 },
  { id: 430, nameFr: "Corboss", type1: "dark", type2: "flying", power: 3 },
  { id: 431, nameFr: "Chaglam", type1: "normal", power: 1 },
  { id: 432, nameFr: "Chaffreux", type1: "normal", power: 2 },
  { id: 433, nameFr: "Korillon", type1: "psychic", power: 1 },
  { id: 434, nameFr: "Moufouette", type1: "poison", type2: "dark", power: 1 },
  { id: 435, nameFr: "Moufflair", type1: "poison", type2: "dark", power: 2 },
  { id: 436, nameFr: "Archéomire", type1: "steel", type2: "psychic", power: 1 },
  { id: 437, nameFr: "Archéodong", type1: "steel", type2: "psychic", power: 3 },
  { id: 438, nameFr: "Manzaï", type1: "rock", power: 1 },
  { id: 439, nameFr: "Mime Jr.", type1: "psychic", type2: "fairy", power: 1 },
  { id: 440, nameFr: "Ptiravi", type1: "normal", power: 1 },
  { id: 441, nameFr: "Pijako", type1: "normal", type2: "flying", power: 2 },
  { id: 442, nameFr: "Spiritomb", type1: "ghost", type2: "dark", power: 3 },
  { id: 443, nameFr: "Griknot", type1: "dragon", type2: "ground", power: 1 },
  { id: 444, nameFr: "Carmache", type1: "dragon", type2: "ground", power: 2 },
  { id: 445, nameFr: "Carchacrok", type1: "dragon", type2: "ground", power: 4 },
  { id: 446, nameFr: "Goinfrex", type1: "normal", power: 2 },
  { id: 447, nameFr: "Riolu", type1: "fighting", power: 1 },
  { id: 448, nameFr: "Lucario", type1: "fighting", type2: "steel", power: 3 },
  { id: 449, nameFr: "Hippopotas", type1: "ground", power: 1 },
  { id: 450, nameFr: "Hippodocus", type1: "ground", power: 3 },
  { id: 451, nameFr: "Rapion", type1: "poison", type2: "bug", power: 1 },
  { id: 452, nameFr: "Drascore", type1: "poison", type2: "dark", power: 3 },
  { id: 453, nameFr: "Cradopaud", type1: "poison", type2: "fighting", power: 1 },
  { id: 454, nameFr: "Coatox", type1: "poison", type2: "fighting", power: 3 },
  { id: 455, nameFr: "Vortente", type1: "grass", power: 2 },
  { id: 456, nameFr: "Écayon", type1: "water", power: 1 },
  { id: 457, nameFr: "Luminéon", type1: "water", power: 2 },
  { id: 458, nameFr: "Babimanta", type1: "water", type2: "flying", power: 1 },
  { id: 459, nameFr: "Blizzi", type1: "grass", type2: "ice", power: 1 },
  { id: 460, nameFr: "Blizzaroi", type1: "grass", type2: "ice", power: 3 },
  { id: 461, nameFr: "Dimoret", type1: "dark", type2: "ice", power: 3 },
  { id: 462, nameFr: "Magnézone", type1: "electric", type2: "steel", power: 3 },
  { id: 463, nameFr: "Coudlangue", type1: "normal", power: 3 },
  { id: 464, nameFr: "Rhinastoc", type1: "ground", type2: "rock", power: 3 },
  { id: 465, nameFr: "Bouldeneu", type1: "grass", power: 3 },
  { id: 466, nameFr: "Élekable", type1: "electric", power: 3 },
  { id: 467, nameFr: "Maganon", type1: "fire", power: 3 },
  { id: 468, nameFr: "Togekiss", type1: "fairy", type2: "flying", power: 3 },
  { id: 469, nameFr: "Yanméga", type1: "bug", type2: "flying", power: 3 },
  { id: 470, nameFr: "Phyllali", type1: "grass", power: 3 },
  { id: 471, nameFr: "Givrali", type1: "ice", power: 3 },
  { id: 472, nameFr: "Scorvol", type1: "ground", type2: "flying", power: 3 },
  { id: 473, nameFr: "Mammochon", type1: "ice", type2: "ground", power: 3 },
  { id: 474, nameFr: "Porygon-Z", type1: "normal", power: 3 },
  { id: 475, nameFr: "Gallame", type1: "psychic", type2: "fighting", power: 3 },
  { id: 476, nameFr: "Tarinorme", type1: "rock", type2: "steel", power: 3 },
  { id: 477, nameFr: "Noctunoir", type1: "ghost", power: 3 },
  { id: 478, nameFr: "Momartik", type1: "ice", type2: "ghost", power: 2 },
  { id: 479, nameFr: "Motisma", type1: "electric", type2: "ghost", power: 3 },
  { id: 480, nameFr: "Créhelf", type1: "psychic", power: 5 },
  { id: 481, nameFr: "Créfollet", type1: "psychic", power: 5 },
  { id: 482, nameFr: "Créfadet", type1: "psychic", power: 5 },
  { id: 483, nameFr: "Dialga", type1: "steel", type2: "dragon", power: 5 },
  { id: 484, nameFr: "Palkia", type1: "water", type2: "dragon", power: 5 },
  { id: 485, nameFr: "Heatran", type1: "fire", type2: "steel", power: 5 },
  { id: 486, nameFr: "Regigigas", type1: "normal", power: 5 },
  { id: 487, nameFr: "Giratina", type1: "ghost", type2: "dragon", power: 5 },
  { id: 488, nameFr: "Cresselia", type1: "psychic", power: 5 },
  { id: 489, nameFr: "Phione", type1: "water", power: 5 },
  { id: 490, nameFr: "Manaphy", type1: "water", power: 5 },
  { id: 491, nameFr: "Darkrai", type1: "dark", power: 5 },
  { id: 492, nameFr: "Shaymin", type1: "grass", power: 5 },
  { id: 493, nameFr: "Arceus", type1: "normal", power: 5 },
  { id: 494, nameFr: "Victini", type1: "psychic", type2: "fire", power: 5 },
  { id: 495, nameFr: "Vipélierre", type1: "grass", power: 1 },
  { id: 496, nameFr: "Lianaja", type1: "grass", power: 2 },
  { id: 497, nameFr: "Majaspic", type1: "grass", power: 3 },
  { id: 498, nameFr: "Gruikui", type1: "fire", power: 1 },
  { id: 499, nameFr: "Grotichon", type1: "fire", type2: "fighting", power: 2 },
  { id: 500, nameFr: "Roitiflam", type1: "fire", type2: "fighting", power: 3 },
  { id: 501, nameFr: "Moustillon", type1: "water", power: 1 },
  { id: 502, nameFr: "Mateloutre", type1: "water", power: 2 },
  { id: 503, nameFr: "Clamiral", type1: "water", power: 3 },
  { id: 504, nameFr: "Ratentif", type1: "normal", power: 1 },
  { id: 505, nameFr: "Miradar", type1: "normal", power: 2 },
  { id: 506, nameFr: "Ponchiot", type1: "normal", power: 1 },
  { id: 507, nameFr: "Ponchien", type1: "normal", power: 2 },
  { id: 508, nameFr: "Mastouffe", type1: "normal", power: 3 },
  { id: 509, nameFr: "Chacripan", type1: "dark", power: 1 },
  { id: 510, nameFr: "Léopardus", type1: "dark", power: 2 },
  { id: 511, nameFr: "Feuillajou", type1: "grass", power: 1 },
  { id: 512, nameFr: "Feuiloutan", type1: "grass", power: 3 },
  { id: 513, nameFr: "Flamajou", type1: "fire", power: 1 },
  { id: 514, nameFr: "Flamoutan", type1: "fire", power: 3 },
  { id: 515, nameFr: "Flotajou", type1: "water", power: 1 },
  { id: 516, nameFr: "Flotoutan", type1: "water", power: 3 },
  { id: 517, nameFr: "Munna", type1: "psychic", power: 1 },
  { id: 518, nameFr: "Mushana", type1: "psychic", power: 3 },
  { id: 519, nameFr: "Poichigeon", type1: "normal", type2: "flying", power: 1 },
  { id: 520, nameFr: "Colombeau", type1: "normal", type2: "flying", power: 2 },
  { id: 521, nameFr: "Déflaisan", type1: "normal", type2: "flying", power: 3 },
  { id: 522, nameFr: "Zébibron", type1: "electric", power: 1 },
  { id: 523, nameFr: "Zéblitz", type1: "electric", power: 3 },
  { id: 524, nameFr: "Nodulithe", type1: "rock", power: 1 },
  { id: 525, nameFr: "Géolithe", type1: "rock", power: 2 },
  { id: 526, nameFr: "Gigalithe", type1: "rock", power: 3 },
  { id: 527, nameFr: "Chovsourir", type1: "psychic", type2: "flying", power: 1 },
  { id: 528, nameFr: "Rhinolove", type1: "psychic", type2: "flying", power: 2 },
  { id: 529, nameFr: "Rototaupe", type1: "ground", power: 1 },
  { id: 530, nameFr: "Minotaupe", type1: "ground", type2: "steel", power: 3 },
  { id: 531, nameFr: "Nanméouïe", type1: "normal", power: 2 },
  { id: 532, nameFr: "Charpenti", type1: "fighting", power: 1 },
  { id: 533, nameFr: "Ouvrifier", type1: "fighting", power: 2 },
  { id: 534, nameFr: "Bétochef", type1: "fighting", power: 3 },
  { id: 535, nameFr: "Tritonde", type1: "water", power: 1 },
  { id: 536, nameFr: "Batracné", type1: "water", type2: "ground", power: 2 },
  { id: 537, nameFr: "Crapustule", type1: "water", type2: "ground", power: 3 },
  { id: 538, nameFr: "Judokrak", type1: "fighting", power: 2 },
  { id: 539, nameFr: "Karaclée", type1: "fighting", power: 2 },
  { id: 540, nameFr: "Larveyette", type1: "bug", type2: "grass", power: 1 },
  { id: 541, nameFr: "Couverdure", type1: "bug", type2: "grass", power: 2 },
  { id: 542, nameFr: "Manternel", type1: "bug", type2: "grass", power: 3 },
  { id: 543, nameFr: "Venipatte", type1: "bug", type2: "poison", power: 1 },
  { id: 544, nameFr: "Scobolide", type1: "bug", type2: "poison", power: 2 },
  { id: 545, nameFr: "Brutapode", type1: "bug", type2: "poison", power: 3 },
  { id: 546, nameFr: "Doudouvet", type1: "grass", type2: "fairy", power: 1 },
  { id: 547, nameFr: "Farfaduvet", type1: "grass", type2: "fairy", power: 2 },
  { id: 548, nameFr: "Chlorobule", type1: "grass", power: 1 },
  { id: 549, nameFr: "Fragilady", type1: "grass", power: 2 },
  { id: 550, nameFr: "Bargantua", type1: "water", power: 2 },
  { id: 551, nameFr: "Mascaïman", type1: "ground", type2: "dark", power: 1 },
  { id: 552, nameFr: "Escroco", type1: "ground", type2: "dark", power: 2 },
  { id: 553, nameFr: "Crocorible", type1: "ground", type2: "dark", power: 3 },
  { id: 554, nameFr: "Darumarond", type1: "fire", power: 1 },
  { id: 555, nameFr: "Darumacho", type1: "fire", power: 2 },
  { id: 556, nameFr: "Maracachi", type1: "grass", power: 2 },
  { id: 557, nameFr: "Crabicoque", type1: "bug", type2: "rock", power: 1 },
  { id: 558, nameFr: "Crabaraque", type1: "bug", type2: "rock", power: 2 },
  { id: 559, nameFr: "Baggiguane", type1: "dark", type2: "fighting", power: 1 },
  { id: 560, nameFr: "Baggaïd", type1: "dark", type2: "fighting", power: 3 },
  { id: 561, nameFr: "Cryptéro", type1: "psychic", type2: "flying", power: 3 },
  { id: 562, nameFr: "Tutafeh", type1: "ghost", power: 1 },
  { id: 563, nameFr: "Tutankafer", type1: "ghost", power: 2 },
  { id: 564, nameFr: "Carapagos", type1: "water", type2: "rock", power: 1 },
  { id: 565, nameFr: "Mégapagos", type1: "water", type2: "rock", power: 3 },
  { id: 566, nameFr: "Arkéapti", type1: "rock", type2: "flying", power: 2 },
  { id: 567, nameFr: "Aéroptéryx", type1: "rock", type2: "flying", power: 3 },
  { id: 568, nameFr: "Miamiasme", type1: "poison", power: 1 },
  { id: 569, nameFr: "Miasmax", type1: "poison", power: 2 },
  { id: 570, nameFr: "Zorua", type1: "dark", power: 1 },
  { id: 571, nameFr: "Zoroark", type1: "dark", power: 3 },
  { id: 572, nameFr: "Chinchidou", type1: "normal", power: 1 },
  { id: 573, nameFr: "Pashmilla", type1: "normal", power: 2 },
  { id: 574, nameFr: "Scrutella", type1: "psychic", power: 1 },
  { id: 575, nameFr: "Mesmérella", type1: "psychic", power: 2 },
  { id: 576, nameFr: "Sidérella", type1: "psychic", power: 3 },
  { id: 577, nameFr: "Nucléos", type1: "psychic", power: 1 },
  { id: 578, nameFr: "Méios", type1: "psychic", power: 2 },
  { id: 579, nameFr: "Symbios", type1: "psychic", power: 3 },
  { id: 580, nameFr: "Couaneton", type1: "water", type2: "flying", power: 1 },
  { id: 581, nameFr: "Lakmécygne", type1: "water", type2: "flying", power: 2 },
  { id: 582, nameFr: "Sorbébé", type1: "ice", power: 1 },
  { id: 583, nameFr: "Sorboul", type1: "ice", power: 2 },
  { id: 584, nameFr: "Sorbouboul", type1: "ice", power: 3 },
  { id: 585, nameFr: "Vivaldaim", type1: "normal", type2: "grass", power: 1 },
  { id: 586, nameFr: "Haydaim", type1: "normal", type2: "grass", power: 2 },
  { id: 587, nameFr: "Emolga", type1: "electric", type2: "flying", power: 2 },
  { id: 588, nameFr: "Carabing", type1: "bug", power: 1 },
  { id: 589, nameFr: "Lançargot", type1: "bug", type2: "steel", power: 3 },
  { id: 590, nameFr: "Trompignon", type1: "grass", type2: "poison", power: 1 },
  { id: 591, nameFr: "Gaulet", type1: "grass", type2: "poison", power: 2 },
  { id: 592, nameFr: "Viskuse", type1: "water", type2: "ghost", power: 1 },
  { id: 593, nameFr: "Moyade", type1: "water", type2: "ghost", power: 2 },
  { id: 594, nameFr: "Mamanbo", type1: "water", power: 2 },
  { id: 595, nameFr: "Statitik", type1: "bug", type2: "electric", power: 1 },
  { id: 596, nameFr: "Mygavolt", type1: "bug", type2: "electric", power: 2 },
  { id: 597, nameFr: "Grindur", type1: "grass", type2: "steel", power: 1 },
  { id: 598, nameFr: "Noacier", type1: "grass", type2: "steel", power: 3 },
  { id: 599, nameFr: "Tic", type1: "steel", power: 1 },
  { id: 600, nameFr: "Clic", type1: "steel", power: 2 },
  { id: 601, nameFr: "Cliticlic", type1: "steel", power: 3 },
  { id: 602, nameFr: "Anchwatt", type1: "electric", power: 1 },
  { id: 603, nameFr: "Lampéroie", type1: "electric", power: 2 },
  { id: 604, nameFr: "Ohmassacre", type1: "electric", power: 3 },
  { id: 605, nameFr: "Lewsor", type1: "psychic", power: 1 },
  { id: 606, nameFr: "Neitram", type1: "psychic", power: 2 },
  { id: 607, nameFr: "Funécire", type1: "ghost", type2: "fire", power: 1 },
  { id: 608, nameFr: "Mélancolux", type1: "ghost", type2: "fire", power: 2 },
  { id: 609, nameFr: "Lugulabre", type1: "ghost", type2: "fire", power: 3 },
  { id: 610, nameFr: "Coupenotte", type1: "dragon", power: 1 },
  { id: 611, nameFr: "Incisache", type1: "dragon", power: 2 },
  { id: 612, nameFr: "Tranchodon", type1: "dragon", power: 3 },
  { id: 613, nameFr: "Polarhume", type1: "ice", power: 1 },
  { id: 614, nameFr: "Polagriffe", type1: "ice", power: 3 },
  { id: 615, nameFr: "Hexagel", type1: "ice", power: 3 },
  { id: 616, nameFr: "Escargaume", type1: "bug", power: 1 },
  { id: 617, nameFr: "Limaspeed", type1: "bug", power: 3 },
  { id: 618, nameFr: "Limonde", type1: "ground", type2: "electric", power: 2 },
  { id: 619, nameFr: "Kungfouine", type1: "fighting", power: 1 },
  { id: 620, nameFr: "Shaofouine", type1: "fighting", power: 3 },
  { id: 621, nameFr: "Drakkarmin", type1: "dragon", power: 3 },
  { id: 622, nameFr: "Gringolem", type1: "ground", type2: "ghost", power: 1 },
  { id: 623, nameFr: "Golemastoc", type1: "ground", type2: "ghost", power: 3 },
  { id: 624, nameFr: "Scalpion", type1: "dark", type2: "steel", power: 1 },
  { id: 625, nameFr: "Scalproie", type1: "dark", type2: "steel", power: 3 },
  { id: 626, nameFr: "Frison", type1: "normal", power: 3 },
  { id: 627, nameFr: "Furaiglon", type1: "normal", type2: "flying", power: 1 },
  { id: 628, nameFr: "Gueriaigle", type1: "normal", type2: "flying", power: 3 },
  { id: 629, nameFr: "Vostourno", type1: "dark", type2: "flying", power: 1 },
  { id: 630, nameFr: "Vaututrice", type1: "dark", type2: "flying", power: 3 },
  { id: 631, nameFr: "Aflamanoir", type1: "fire", power: 3 },
  { id: 632, nameFr: "Fermite", type1: "bug", type2: "steel", power: 3 },
  { id: 633, nameFr: "Solochi", type1: "dark", type2: "dragon", power: 1 },
  { id: 634, nameFr: "Diamat", type1: "dark", type2: "dragon", power: 2 },
  { id: 635, nameFr: "Trioxhydre", type1: "dark", type2: "dragon", power: 4 },
  { id: 636, nameFr: "Pyronille", type1: "bug", type2: "fire", power: 1 },
  { id: 637, nameFr: "Pyrax", type1: "bug", type2: "fire", power: 3 },
  { id: 638, nameFr: "Cobaltium", type1: "steel", type2: "fighting", power: 5 },
  { id: 639, nameFr: "Terrakium", type1: "rock", type2: "fighting", power: 5 },
  { id: 640, nameFr: "Viridium", type1: "grass", type2: "fighting", power: 5 },
  { id: 641, nameFr: "Boréas", type1: "flying", power: 5 },
  { id: 642, nameFr: "Fulguris", type1: "electric", type2: "flying", power: 5 },
  { id: 643, nameFr: "Reshiram", type1: "dragon", type2: "fire", power: 5 },
  { id: 644, nameFr: "Zekrom", type1: "dragon", type2: "electric", power: 5 },
  { id: 645, nameFr: "Démétéros", type1: "ground", type2: "flying", power: 5 },
  { id: 646, nameFr: "Kyurem", type1: "dragon", type2: "ice", power: 5 },
  { id: 647, nameFr: "Keldeo", type1: "water", type2: "fighting", power: 5 },
  { id: 648, nameFr: "Meloetta", type1: "normal", type2: "psychic", power: 5 },
  { id: 649, nameFr: "Genesect", type1: "bug", type2: "steel", power: 5 },
  { id: 650, nameFr: "Marisson", type1: "grass", power: 1 },
  { id: 651, nameFr: "Boguérisse", type1: "grass", power: 2 },
  { id: 652, nameFr: "Blindépique", type1: "grass", type2: "fighting", power: 3 },
  { id: 653, nameFr: "Feunnec", type1: "fire", power: 1 },
  { id: 654, nameFr: "Roussil", type1: "fire", power: 2 },
  { id: 655, nameFr: "Goupelin", type1: "fire", type2: "psychic", power: 3 },
  { id: 656, nameFr: "Grenousse", type1: "water", power: 1 },
  { id: 657, nameFr: "Croâporal", type1: "water", power: 2 },
  { id: 658, nameFr: "Amphinobi", type1: "water", type2: "dark", power: 3 },
  { id: 659, nameFr: "Sapereau", type1: "normal", power: 1 },
  { id: 660, nameFr: "Excavarenne", type1: "normal", type2: "ground", power: 2 },
  { id: 661, nameFr: "Passerouge", type1: "normal", type2: "flying", power: 1 },
  { id: 662, nameFr: "Braisillon", type1: "fire", type2: "flying", power: 2 },
  { id: 663, nameFr: "Flambusard", type1: "fire", type2: "flying", power: 3 },
  { id: 664, nameFr: "Lépidonille", type1: "bug", power: 1 },
  { id: 665, nameFr: "Pérégrain", type1: "bug", power: 1 },
  { id: 666, nameFr: "Prismillon", type1: "bug", type2: "flying", power: 2 },
  { id: 667, nameFr: "Hélionceau", type1: "fire", type2: "normal", power: 1 },
  { id: 668, nameFr: "Némélios", type1: "fire", type2: "normal", power: 3 },
  { id: 669, nameFr: "Flabébé", type1: "fairy", power: 1 },
  { id: 670, nameFr: "Floette", type1: "fairy", power: 2 },
  { id: 671, nameFr: "Florges", type1: "fairy", power: 3 },
  { id: 672, nameFr: "Cabriolaine", type1: "grass", power: 1 },
  { id: 673, nameFr: "Chevroum", type1: "grass", power: 3 },
  { id: 674, nameFr: "Pandespiègle", type1: "fighting", power: 1 },
  { id: 675, nameFr: "Pandarbare", type1: "fighting", type2: "dark", power: 3 },
  { id: 676, nameFr: "Couafarel", type1: "normal", power: 2 },
  { id: 677, nameFr: "Psystigri", type1: "psychic", power: 1 },
  { id: 678, nameFr: "Mistigrix", type1: "psychic", power: 2 },
  { id: 679, nameFr: "Monorpale", type1: "steel", type2: "ghost", power: 1 },
  { id: 680, nameFr: "Dimoclès", type1: "steel", type2: "ghost", power: 2 },
  { id: 681, nameFr: "Exagide", type1: "steel", type2: "ghost", power: 3 },
  { id: 682, nameFr: "Fluvetin", type1: "fairy", power: 1 },
  { id: 683, nameFr: "Cocotine", type1: "fairy", power: 2 },
  { id: 684, nameFr: "Sucroquin", type1: "fairy", power: 1 },
  { id: 685, nameFr: "Cupcanaille", type1: "fairy", power: 2 },
  { id: 686, nameFr: "Sepiatop", type1: "dark", type2: "psychic", power: 1 },
  { id: 687, nameFr: "Sepiatroce", type1: "dark", type2: "psychic", power: 2 },
  { id: 688, nameFr: "Opermine", type1: "rock", type2: "water", power: 1 },
  { id: 689, nameFr: "Golgopathe", type1: "rock", type2: "water", power: 3 },
  { id: 690, nameFr: "Venalgue", type1: "poison", type2: "water", power: 1 },
  { id: 691, nameFr: "Kravarech", type1: "poison", type2: "dragon", power: 3 },
  { id: 692, nameFr: "Flingouste", type1: "water", power: 1 },
  { id: 693, nameFr: "Gamblast", type1: "water", power: 3 },
  { id: 694, nameFr: "Galvaran", type1: "electric", type2: "normal", power: 1 },
  { id: 695, nameFr: "Iguolta", type1: "electric", type2: "normal", power: 2 },
  { id: 696, nameFr: "Ptyranidur", type1: "rock", type2: "dragon", power: 1 },
  { id: 697, nameFr: "Rexillius", type1: "rock", type2: "dragon", power: 3 },
  { id: 698, nameFr: "Amagara", type1: "rock", type2: "ice", power: 1 },
  { id: 699, nameFr: "Dragmara", type1: "rock", type2: "ice", power: 3 },
  { id: 700, nameFr: "Nymphali", type1: "fairy", power: 3 },
  { id: 701, nameFr: "Brutalibré", type1: "fighting", type2: "flying", power: 3 },
  { id: 702, nameFr: "Dedenne", type1: "electric", type2: "fairy", power: 2 },
  { id: 703, nameFr: "Strassie", type1: "rock", type2: "fairy", power: 3 },
  { id: 704, nameFr: "Mucuscule", type1: "dragon", power: 1 },
  { id: 705, nameFr: "Colimucus", type1: "dragon", power: 2 },
  { id: 706, nameFr: "Muplodocus", type1: "dragon", power: 4 },
  { id: 707, nameFr: "Trousselin", type1: "steel", type2: "fairy", power: 2 },
  { id: 708, nameFr: "Brocélôme", type1: "ghost", type2: "grass", power: 1 },
  { id: 709, nameFr: "Desséliande", type1: "ghost", type2: "grass", power: 2 },
  { id: 710, nameFr: "Pitrouille", type1: "ghost", type2: "grass", power: 1 },
  { id: 711, nameFr: "Banshitrouye", type1: "ghost", type2: "grass", power: 3 },
  { id: 712, nameFr: "Grelaçon", type1: "ice", power: 1 },
  { id: 713, nameFr: "Séracrawl", type1: "ice", power: 3 },
  { id: 714, nameFr: "Sonistrelle", type1: "flying", type2: "dragon", power: 1 },
  { id: 715, nameFr: "Bruyverne", type1: "flying", type2: "dragon", power: 3 },
  { id: 716, nameFr: "Xerneas", type1: "fairy", power: 5 },
  { id: 717, nameFr: "Yveltal", type1: "dark", type2: "flying", power: 5 },
  { id: 718, nameFr: "Zygarde", type1: "dragon", type2: "ground", power: 5 },
  { id: 719, nameFr: "Diancie", type1: "rock", type2: "fairy", power: 5 },
  { id: 720, nameFr: "Hoopa", type1: "psychic", type2: "ghost", power: 5 },
  { id: 721, nameFr: "Volcanion", type1: "fire", type2: "water", power: 5 },
  { id: 722, nameFr: "Brindibou", type1: "grass", type2: "flying", power: 1 },
  { id: 723, nameFr: "Efflèche", type1: "grass", type2: "flying", power: 2 },
  { id: 724, nameFr: "Archéduc", type1: "grass", type2: "ghost", power: 3 },
  { id: 725, nameFr: "Flamiaou", type1: "fire", power: 1 },
  { id: 726, nameFr: "Matoufeu", type1: "fire", power: 2 },
  { id: 727, nameFr: "Félinferno", type1: "fire", type2: "dark", power: 3 },
  { id: 728, nameFr: "Otaquin", type1: "water", power: 1 },
  { id: 729, nameFr: "Otarlette", type1: "water", power: 2 },
  { id: 730, nameFr: "Oratoria", type1: "water", type2: "fairy", power: 3 },
  { id: 731, nameFr: "Picassaut", type1: "normal", type2: "flying", power: 1 },
  { id: 732, nameFr: "Piclairon", type1: "normal", type2: "flying", power: 2 },
  { id: 733, nameFr: "Bazoucan", type1: "normal", type2: "flying", power: 3 },
  { id: 734, nameFr: "Manglouton", type1: "normal", power: 1 },
  { id: 735, nameFr: "Argouste", type1: "normal", power: 2 },
  { id: 736, nameFr: "Larvibule", type1: "bug", power: 1 },
  { id: 737, nameFr: "Chrysapile", type1: "bug", type2: "electric", power: 2 },
  { id: 738, nameFr: "Lucanon", type1: "bug", type2: "electric", power: 3 },
  { id: 739, nameFr: "Crabagarre", type1: "fighting", power: 1 },
  { id: 740, nameFr: "Crabominable", type1: "fighting", type2: "ice", power: 2 },
  { id: 741, nameFr: "Plumeline", type1: "fire", type2: "flying", power: 2 },
  { id: 742, nameFr: "Bombydou", type1: "bug", type2: "fairy", power: 1 },
  { id: 743, nameFr: "Rubombelle", type1: "bug", type2: "fairy", power: 2 },
  { id: 744, nameFr: "Rocabot", type1: "rock", power: 1 },
  { id: 745, nameFr: "Lougaroc", type1: "rock", power: 2 },
  { id: 746, nameFr: "Froussardine", type1: "water", power: 1 },
  { id: 747, nameFr: "Vorastérie", type1: "poison", type2: "water", power: 1 },
  { id: 748, nameFr: "Prédastérie", type1: "poison", type2: "water", power: 3 },
  { id: 749, nameFr: "Tiboudet", type1: "ground", power: 2 },
  { id: 750, nameFr: "Bourrinos", type1: "ground", power: 3 },
  { id: 751, nameFr: "Araqua", type1: "water", type2: "bug", power: 1 },
  { id: 752, nameFr: "Tarenbulle", type1: "water", type2: "bug", power: 2 },
  { id: 753, nameFr: "Mimantis", type1: "grass", power: 1 },
  { id: 754, nameFr: "Floramantis", type1: "grass", power: 2 },
  { id: 755, nameFr: "Spododo", type1: "grass", type2: "fairy", power: 1 },
  { id: 756, nameFr: "Lampignon", type1: "grass", type2: "fairy", power: 2 },
  { id: 757, nameFr: "Tritox", type1: "poison", type2: "fire", power: 1 },
  { id: 758, nameFr: "Malamandre", type1: "poison", type2: "fire", power: 2 },
  { id: 759, nameFr: "Nounourson", type1: "normal", type2: "fighting", power: 1 },
  { id: 760, nameFr: "Chelours", type1: "normal", type2: "fighting", power: 3 },
  { id: 761, nameFr: "Croquine", type1: "grass", power: 1 },
  { id: 762, nameFr: "Candine", type1: "grass", power: 1 },
  { id: 763, nameFr: "Sucreine", type1: "grass", power: 3 },
  { id: 764, nameFr: "Guérilande", type1: "fairy", power: 3 },
  { id: 765, nameFr: "Gouroutan", type1: "normal", type2: "psychic", power: 3 },
  { id: 766, nameFr: "Quartermac", type1: "fighting", power: 3 },
  { id: 767, nameFr: "Sovkipou", type1: "bug", type2: "water", power: 1 },
  { id: 768, nameFr: "Sarmuraï", type1: "bug", type2: "water", power: 3 },
  { id: 769, nameFr: "Bacabouh", type1: "ghost", type2: "ground", power: 1 },
  { id: 770, nameFr: "Trépassable", type1: "ghost", type2: "ground", power: 2 },
  { id: 771, nameFr: "Concombaffe", type1: "water", power: 2 },
  { id: 772, nameFr: "Type:0", type1: "normal", power: 3 },
  { id: 773, nameFr: "Silvallié", type1: "normal", power: 4 },
  { id: 774, nameFr: "Météno", type1: "rock", type2: "flying", power: 3 },
  { id: 775, nameFr: "Dodoala", type1: "normal", power: 2 },
  { id: 776, nameFr: "Boumata", type1: "fire", type2: "dragon", power: 3 },
  { id: 777, nameFr: "Togedemaru", type1: "electric", type2: "steel", power: 2 },
  { id: 778, nameFr: "Mimiqui", type1: "ghost", type2: "fairy", power: 2 },
  { id: 779, nameFr: "Denticrisse", type1: "water", type2: "psychic", power: 2 },
  { id: 780, nameFr: "Draïeul", type1: "normal", type2: "dragon", power: 3 },
  { id: 781, nameFr: "Sinistrail", type1: "ghost", type2: "grass", power: 3 },
  { id: 782, nameFr: "Bébécaille", type1: "dragon", power: 1 },
  { id: 783, nameFr: "Écaïd", type1: "dragon", type2: "fighting", power: 2 },
  { id: 784, nameFr: "Ékaïser", type1: "dragon", type2: "fighting", power: 4 },
  { id: 785, nameFr: "Tokorico", type1: "electric", type2: "fairy", power: 5 },
  { id: 786, nameFr: "Tokopiyon", type1: "psychic", type2: "fairy", power: 5 },
  { id: 787, nameFr: "Tokotoro", type1: "grass", type2: "fairy", power: 5 },
  { id: 788, nameFr: "Tokopisco", type1: "water", type2: "fairy", power: 5 },
  { id: 789, nameFr: "Cosmog", type1: "psychic", power: 1 },
  { id: 790, nameFr: "Cosmovum", type1: "psychic", power: 2 },
  { id: 791, nameFr: "Solgaleo", type1: "psychic", type2: "steel", power: 5 },
  { id: 792, nameFr: "Lunala", type1: "psychic", type2: "ghost", power: 5 },
  { id: 793, nameFr: "Zéroïd", type1: "rock", type2: "poison", power: 4 },
  { id: 794, nameFr: "Mouscoto", type1: "bug", type2: "fighting", power: 4 },
  { id: 795, nameFr: "Cancrelove", type1: "bug", type2: "fighting", power: 4 },
  { id: 796, nameFr: "Câblifère", type1: "electric", power: 4 },
  { id: 797, nameFr: "Bamboiselle", type1: "steel", type2: "flying", power: 4 },
  { id: 798, nameFr: "Katagami", type1: "grass", type2: "steel", power: 4 },
  { id: 799, nameFr: "Engloutyran", type1: "dark", type2: "dragon", power: 4 },
  { id: 800, nameFr: "Necrozma", type1: "psychic", power: 5 },
  { id: 801, nameFr: "Magearna", type1: "steel", type2: "fairy", power: 5 },
  { id: 802, nameFr: "Marshadow", type1: "fighting", type2: "ghost", power: 5 },
  { id: 803, nameFr: "Vémini", type1: "poison", power: 2 },
  { id: 804, nameFr: "Mandrillon", type1: "poison", type2: "dragon", power: 3 },
  { id: 805, nameFr: "Ama-Ama", type1: "rock", type2: "steel", power: 4 },
  { id: 806, nameFr: "Pierroteknik", type1: "fire", type2: "ghost", power: 4 },
  { id: 807, nameFr: "Zeraora", type1: "electric", power: 5 },
  { id: 808, nameFr: "Meltan", type1: "steel", power: 5 },
  { id: 809, nameFr: "Melmetal", type1: "steel", power: 5 },
  { id: 810, nameFr: "Ouistempo", type1: "grass", power: 1 },
  { id: 811, nameFr: "Badabouin", type1: "grass", power: 2 },
  { id: 812, nameFr: "Gorythmic", type1: "grass", power: 3 },
  { id: 813, nameFr: "Flambino", type1: "fire", power: 1 },
  { id: 814, nameFr: "Lapyro", type1: "fire", power: 2 },
  { id: 815, nameFr: "Pyrobut", type1: "fire", power: 3 },
  { id: 816, nameFr: "Larméléon", type1: "water", power: 1 },
  { id: 817, nameFr: "Arrozard", type1: "water", power: 2 },
  { id: 818, nameFr: "Lézargus", type1: "water", power: 3 },
  { id: 819, nameFr: "Rongourmand", type1: "normal", power: 1 },
  { id: 820, nameFr: "Rongrigou", type1: "normal", power: 2 },
  { id: 821, nameFr: "Minisange", type1: "flying", power: 1 },
  { id: 822, nameFr: "Bleuseille", type1: "flying", power: 2 },
  { id: 823, nameFr: "Corvaillus", type1: "flying", type2: "steel", power: 3 },
  { id: 824, nameFr: "Larvadar", type1: "bug", power: 1 },
  { id: 825, nameFr: "Coléodôme", type1: "bug", type2: "psychic", power: 2 },
  { id: 826, nameFr: "Astronelle", type1: "bug", type2: "psychic", power: 3 },
  { id: 827, nameFr: "Goupilou", type1: "dark", power: 1 },
  { id: 828, nameFr: "Roublenard", type1: "dark", power: 2 },
  { id: 829, nameFr: "Tournicoton", type1: "grass", power: 1 },
  { id: 830, nameFr: "Blancoton", type1: "grass", power: 2 },
  { id: 831, nameFr: "Moumouton", type1: "normal", power: 1 },
  { id: 832, nameFr: "Moumouflon", type1: "normal", power: 3 },
  { id: 833, nameFr: "Khélocrok", type1: "water", power: 1 },
  { id: 834, nameFr: "Torgamord", type1: "water", type2: "rock", power: 3 },
  { id: 835, nameFr: "Voltoutou", type1: "electric", power: 1 },
  { id: 836, nameFr: "Fulgudog", type1: "electric", power: 3 },
  { id: 837, nameFr: "Charbi", type1: "rock", power: 1 },
  { id: 838, nameFr: "Wagomine", type1: "rock", type2: "fire", power: 2 },
  { id: 839, nameFr: "Monthracite", type1: "rock", type2: "fire", power: 3 },
  { id: 840, nameFr: "Verpom", type1: "grass", type2: "dragon", power: 1 },
  { id: 841, nameFr: "Pomdrapi", type1: "grass", type2: "dragon", power: 3 },
  { id: 842, nameFr: "Dratatin", type1: "grass", type2: "dragon", power: 3 },
  { id: 843, nameFr: "Dunaja", type1: "ground", power: 1 },
  { id: 844, nameFr: "Dunaconda", type1: "ground", power: 3 },
  { id: 845, nameFr: "Nigosier", type1: "flying", type2: "water", power: 2 },
  { id: 846, nameFr: "Embrochet", type1: "water", power: 1 },
  { id: 847, nameFr: "Hastacuda", type1: "water", power: 3 },
  { id: 848, nameFr: "Toxizap", type1: "electric", type2: "poison", power: 1 },
  { id: 849, nameFr: "Salarsen", type1: "electric", type2: "poison", power: 3 },
  { id: 850, nameFr: "Grillepattes", type1: "fire", type2: "bug", power: 1 },
  { id: 851, nameFr: "Scolocendre", type1: "fire", type2: "bug", power: 3 },
  { id: 852, nameFr: "Poulpaf", type1: "fighting", power: 1 },
  { id: 853, nameFr: "Krakos", type1: "fighting", power: 2 },
  { id: 854, nameFr: "Théffroi", type1: "ghost", power: 1 },
  { id: 855, nameFr: "Polthégeist", type1: "ghost", power: 3 },
  { id: 856, nameFr: "Bibichut", type1: "psychic", power: 1 },
  { id: 857, nameFr: "Chapotus", type1: "psychic", power: 2 },
  { id: 858, nameFr: "Sorcilence", type1: "psychic", type2: "fairy", power: 3 },
  { id: 859, nameFr: "Grimalin", type1: "dark", type2: "fairy", power: 1 },
  { id: 860, nameFr: "Fourbelin", type1: "dark", type2: "fairy", power: 2 },
  { id: 861, nameFr: "Angoliath", type1: "dark", type2: "fairy", power: 3 },
  { id: 862, nameFr: "Ixon", type1: "dark", type2: "normal", power: 3 },
  { id: 863, nameFr: "Berserkatt", type1: "steel", power: 2 },
  { id: 864, nameFr: "Corayôme", type1: "ghost", power: 3 },
  { id: 865, nameFr: "Palarticho", type1: "fighting", power: 3 },
  { id: 866, nameFr: "M. Glaquette", type1: "ice", type2: "psychic", power: 3 },
  { id: 867, nameFr: "Tutétékri", type1: "ground", type2: "ghost", power: 2 },
  { id: 868, nameFr: "Crèmy", type1: "fairy", power: 1 },
  { id: 869, nameFr: "Charmilly", type1: "fairy", power: 3 },
  { id: 870, nameFr: "Hexadron", type1: "fighting", power: 2 },
  { id: 871, nameFr: "Wattapik", type1: "electric", power: 2 },
  { id: 872, nameFr: "Frissonille", type1: "ice", type2: "bug", power: 1 },
  { id: 873, nameFr: "Beldeneige", type1: "ice", type2: "bug", power: 2 },
  { id: 874, nameFr: "Dolman", type1: "rock", power: 2 },
  { id: 875, nameFr: "Bekaglaçon", type1: "ice", power: 2 },
  { id: 876, nameFr: "Wimessir", type1: "psychic", type2: "normal", power: 2 },
  { id: 877, nameFr: "Morpeko", type1: "electric", type2: "dark", power: 2 },
  { id: 878, nameFr: "Charibari", type1: "steel", power: 1 },
  { id: 879, nameFr: "Pachyradjah", type1: "steel", power: 3 },
  { id: 880, nameFr: "Galvagon", type1: "electric", type2: "dragon", power: 3 },
  { id: 881, nameFr: "Galvagla", type1: "electric", type2: "ice", power: 3 },
  { id: 882, nameFr: "Hydragon", type1: "water", type2: "dragon", power: 3 },
  { id: 883, nameFr: "Hydragla", type1: "water", type2: "ice", power: 3 },
  { id: 884, nameFr: "Duralugon", type1: "steel", type2: "dragon", power: 3 },
  { id: 885, nameFr: "Fantyrm", type1: "dragon", type2: "ghost", power: 1 },
  { id: 886, nameFr: "Dispareptil", type1: "dragon", type2: "ghost", power: 2 },
  { id: 887, nameFr: "Lanssorien", type1: "dragon", type2: "ghost", power: 4 },
  { id: 888, nameFr: "Zacian", type1: "fairy", power: 5 },
  { id: 889, nameFr: "Zamazenta", type1: "fighting", power: 5 },
  { id: 890, nameFr: "Éthernatos", type1: "poison", type2: "dragon", power: 5 },
  { id: 891, nameFr: "Wushours", type1: "fighting", power: 2 },
  { id: 892, nameFr: "Shifours", type1: "fighting", type2: "dark", power: 5 },
  { id: 893, nameFr: "Zarude", type1: "dark", type2: "grass", power: 5 },
  { id: 894, nameFr: "Regieleki", type1: "electric", power: 5 },
  { id: 895, nameFr: "Regidrago", type1: "dragon", power: 5 },
  { id: 896, nameFr: "Blizzeval", type1: "ice", power: 5 },
  { id: 897, nameFr: "Spectreval", type1: "ghost", power: 5 },
  { id: 898, nameFr: "Sylveroy", type1: "psychic", type2: "grass", power: 5 },
  { id: 899, nameFr: "Cerbyllin", type1: "normal", type2: "psychic", power: 3 },
  { id: 900, nameFr: "Hachécateur", type1: "bug", type2: "rock", power: 3 },
  { id: 901, nameFr: "Ursaking", type1: "ground", type2: "normal", power: 3 },
  { id: 902, nameFr: "Paragruel", type1: "water", type2: "ghost", power: 3 },
  { id: 903, nameFr: "Farfurex", type1: "fighting", type2: "poison", power: 3 },
  { id: 904, nameFr: "Qwilpik", type1: "dark", type2: "poison", power: 3 },
  { id: 905, nameFr: "Amovénus", type1: "fairy", type2: "flying", power: 4 },
  { id: 906, nameFr: "Poussacha", type1: "grass", power: 1 },
  { id: 907, nameFr: "Matourgeon", type1: "grass", power: 2 },
  { id: 908, nameFr: "Miascarade", type1: "grass", type2: "dark", power: 3 },
  { id: 909, nameFr: "Chochodile", type1: "fire", power: 1 },
  { id: 910, nameFr: "Crocogril", type1: "fire", power: 2 },
  { id: 911, nameFr: "Flâmigator", type1: "fire", type2: "ghost", power: 3 },
  { id: 912, nameFr: "Coiffeton", type1: "water", power: 1 },
  { id: 913, nameFr: "Canarbello", type1: "water", power: 2 },
  { id: 914, nameFr: "Palmaval", type1: "water", type2: "fighting", power: 3 },
  { id: 915, nameFr: "Gourmelet", type1: "normal", power: 1 },
  { id: 916, nameFr: "Fragroin", type1: "normal", power: 3 },
  { id: 917, nameFr: "Tissenboule", type1: "bug", power: 1 },
  { id: 918, nameFr: "Filentrappe", type1: "bug", power: 2 },
  { id: 919, nameFr: "Lilliterelle", type1: "bug", power: 1 },
  { id: 920, nameFr: "Gambex", type1: "bug", type2: "dark", power: 2 },
  { id: 921, nameFr: "Pohm", type1: "electric", power: 1 },
  { id: 922, nameFr: "Pohmotte", type1: "electric", type2: "fighting", power: 2 },
  { id: 923, nameFr: "Pohmarmotte", type1: "electric", type2: "fighting", power: 3 },
  { id: 924, nameFr: "Compagnol", type1: "normal", power: 1 },
  { id: 925, nameFr: "Famignol", type1: "normal", power: 2 },
  { id: 926, nameFr: "Pâtachiot", type1: "fairy", power: 1 },
  { id: 927, nameFr: "Briochien", type1: "fairy", power: 2 },
  { id: 928, nameFr: "Olivini", type1: "grass", type2: "normal", power: 1 },
  { id: 929, nameFr: "Olivado", type1: "grass", type2: "normal", power: 2 },
  { id: 930, nameFr: "Arboliva", type1: "grass", type2: "normal", power: 3 },
  { id: 931, nameFr: "Tapatoès", type1: "normal", type2: "flying", power: 2 },
  { id: 932, nameFr: "Selutin", type1: "rock", power: 1 },
  { id: 933, nameFr: "Amassel", type1: "rock", power: 2 },
  { id: 934, nameFr: "Gigansel", type1: "rock", power: 3 },
  { id: 935, nameFr: "Charbambin", type1: "fire", power: 1 },
  { id: 936, nameFr: "Carmadura", type1: "fire", type2: "psychic", power: 3 },
  { id: 937, nameFr: "Malvalame", type1: "fire", type2: "ghost", power: 3 },
  { id: 938, nameFr: "Têtampoule", type1: "electric", power: 1 },
  { id: 939, nameFr: "Ampibidou", type1: "electric", power: 3 },
  { id: 940, nameFr: "Zapétrel", type1: "electric", type2: "flying", power: 1 },
  { id: 941, nameFr: "Fulgulairo", type1: "electric", type2: "flying", power: 3 },
  { id: 942, nameFr: "Grondogue", type1: "dark", power: 1 },
  { id: 943, nameFr: "Dogrino", type1: "dark", power: 2 },
  { id: 944, nameFr: "Gribouraigne", type1: "poison", type2: "normal", power: 1 },
  { id: 945, nameFr: "Tag-Tag", type1: "poison", type2: "normal", power: 2 },
  { id: 946, nameFr: "Virovent", type1: "grass", type2: "ghost", power: 1 },
  { id: 947, nameFr: "Virevorreur", type1: "grass", type2: "ghost", power: 3 },
  { id: 948, nameFr: "Terracool", type1: "ground", type2: "grass", power: 1 },
  { id: 949, nameFr: "Terracruel", type1: "ground", type2: "grass", power: 3 },
  { id: 950, nameFr: "Craparoi", type1: "rock", power: 2 },
  { id: 951, nameFr: "Pimito", type1: "grass", power: 1 },
  { id: 952, nameFr: "Scovilain", type1: "grass", type2: "fire", power: 3 },
  { id: 953, nameFr: "Léboulérou", type1: "bug", power: 1 },
  { id: 954, nameFr: "Bérasca", type1: "bug", type2: "psychic", power: 2 },
  { id: 955, nameFr: "Flotillon", type1: "psychic", power: 1 },
  { id: 956, nameFr: "Cléopsytra", type1: "psychic", power: 2 },
  { id: 957, nameFr: "Forgerette", type1: "fairy", type2: "steel", power: 1 },
  { id: 958, nameFr: "Forgella", type1: "fairy", type2: "steel", power: 2 },
  { id: 959, nameFr: "Forgelina", type1: "fairy", type2: "steel", power: 3 },
  { id: 960, nameFr: "Taupikeau", type1: "water", power: 1 },
  { id: 961, nameFr: "Triopikeau", type1: "water", power: 2 },
  { id: 962, nameFr: "Lestombaile", type1: "flying", type2: "dark", power: 2 },
  { id: 963, nameFr: "Dofin", type1: "water", power: 1 },
  { id: 964, nameFr: "Superdofin", type1: "water", power: 2 },
  { id: 965, nameFr: "Vrombi", type1: "steel", type2: "poison", power: 1 },
  { id: 966, nameFr: "Vrombotor", type1: "steel", type2: "poison", power: 3 },
  { id: 967, nameFr: "Motorizard", type1: "dragon", type2: "normal", power: 3 },
  { id: 968, nameFr: "Ferdeter", type1: "steel", power: 3 },
  { id: 969, nameFr: "Germéclat", type1: "rock", type2: "poison", power: 1 },
  { id: 970, nameFr: "Floréclat", type1: "rock", type2: "poison", power: 3 },
  { id: 971, nameFr: "Toutombe", type1: "ghost", power: 1 },
  { id: 972, nameFr: "Tomberro", type1: "ghost", power: 3 },
  { id: 973, nameFr: "Flamenroule", type1: "flying", type2: "fighting", power: 3 },
  { id: 974, nameFr: "Piétacé", type1: "ice", power: 1 },
  { id: 975, nameFr: "Balbalèze", type1: "ice", power: 3 },
  { id: 976, nameFr: "Délestin", type1: "water", type2: "psychic", power: 2 },
  { id: 977, nameFr: "Oyacata", type1: "water", power: 3 },
  { id: 978, nameFr: "Nigirigon", type1: "dragon", type2: "water", power: 2 },
  { id: 979, nameFr: "Courrousinge", type1: "fighting", type2: "ghost", power: 3 },
  { id: 980, nameFr: "Terraiste", type1: "poison", type2: "ground", power: 2 },
  { id: 981, nameFr: "Farigiraf", type1: "normal", type2: "psychic", power: 3 },
  { id: 982, nameFr: "Deusolourdo", type1: "normal", power: 3 },
  { id: 983, nameFr: "Scalpereur", type1: "dark", type2: "steel", power: 3 },
  { id: 984, nameFr: "Fort-Ivoire", type1: "ground", type2: "fighting", power: 4 },
  { id: 985, nameFr: "Hurle-Queue", type1: "fairy", type2: "psychic", power: 4 },
  { id: 986, nameFr: "Fongus-Furie", type1: "grass", type2: "dark", power: 4 },
  { id: 987, nameFr: "Flotte-Mèche", type1: "ghost", type2: "fairy", power: 4 },
  { id: 988, nameFr: "Rampe-Ailes", type1: "bug", type2: "fighting", power: 4 },
  { id: 989, nameFr: "Pelage-Sablé", type1: "electric", type2: "ground", power: 4 },
  { id: 990, nameFr: "Roue-de-Fer", type1: "ground", type2: "steel", power: 4 },
  { id: 991, nameFr: "Hotte-de-Fer", type1: "ice", type2: "water", power: 4 },
  { id: 992, nameFr: "Paume-de-Fer", type1: "fighting", type2: "electric", power: 4 },
  { id: 993, nameFr: "Têtes-de-Fer", type1: "dark", type2: "flying", power: 4 },
  { id: 994, nameFr: "Mite-de-Fer", type1: "fire", type2: "poison", power: 4 },
  { id: 995, nameFr: "Épine-de-Fer", type1: "rock", type2: "electric", power: 4 },
  { id: 996, nameFr: "Frigodo", type1: "dragon", type2: "ice", power: 1 },
  { id: 997, nameFr: "Cryodo", type1: "dragon", type2: "ice", power: 2 },
  { id: 998, nameFr: "Glaivodo", type1: "dragon", type2: "ice", power: 4 },
  { id: 999, nameFr: "Mordudor", type1: "ghost", power: 1 },
  { id: 1000, nameFr: "Gromago", type1: "steel", type2: "ghost", power: 3 },
  { id: 1001, nameFr: "Chongjian", type1: "dark", type2: "grass", power: 5 },
  { id: 1002, nameFr: "Baojian", type1: "dark", type2: "ice", power: 5 },
  { id: 1003, nameFr: "Dinglu", type1: "dark", type2: "ground", power: 5 },
  { id: 1004, nameFr: "Yuyu", type1: "dark", type2: "fire", power: 5 },
  { id: 1005, nameFr: "Rugit-Lune", type1: "dragon", type2: "dark", power: 5 },
  { id: 1006, nameFr: "Garde-de-Fer", type1: "fairy", type2: "fighting", power: 5 },
  { id: 1007, nameFr: "Koraidon", type1: "fighting", type2: "dragon", power: 5 },
  { id: 1008, nameFr: "Miraidon", type1: "electric", type2: "dragon", power: 5 },
  { id: 1009, nameFr: "Serpente-Eau", type1: "water", type2: "dragon", power: 5 },
  { id: 1010, nameFr: "Vert-de-Fer", type1: "grass", type2: "psychic", power: 5 },
  { id: 1011, nameFr: "Pomdramour", type1: "grass", type2: "dragon", power: 2 },
  { id: 1012, nameFr: "Poltchageist", type1: "grass", type2: "ghost", power: 1 },
  { id: 1013, nameFr: "Théffroyable", type1: "grass", type2: "ghost", power: 3 },
  { id: 1014, nameFr: "Félicanis", type1: "poison", type2: "fighting", power: 3 },
  { id: 1015, nameFr: "Fortusimia", type1: "poison", type2: "psychic", power: 3 },
  { id: 1016, nameFr: "Favianos", type1: "poison", type2: "fairy", power: 3 },
  { id: 1017, nameFr: "Ogerpon (Teal Mask)", type1: "grass", power: 5 },
  { id: 1018, nameFr: "Pondralugon", type1: "steel", type2: "dragon", power: 4 },
  { id: 1019, nameFr: "Pomdorochi", type1: "grass", type2: "dragon", power: 3 },
  { id: 1020, nameFr: "Feu-Perçant", type1: "fire", type2: "dragon", power: 5 },
  { id: 1021, nameFr: "Ire-Foudre", type1: "electric", type2: "dragon", power: 5 },
  { id: 1022, nameFr: "Roc-de-Fer", type1: "rock", type2: "psychic", power: 5 },
  { id: 1023, nameFr: "Chef-de-Fer", type1: "steel", type2: "psychic", power: 5 },
  { id: 1024, nameFr: "Terapagos", type1: "normal", power: 5 },
  { id: 1025, nameFr: "Pêchaminus", type1: "poison", type2: "ghost", power: 5 },
  { id: 10001, nameFr: "Deoxys (Attack)", type1: "psychic", power: 5 },
  { id: 10002, nameFr: "Deoxys (Defense)", type1: "psychic", power: 5 },
  { id: 10003, nameFr: "Deoxys (Speed)", type1: "psychic", power: 5 },
  { id: 10004, nameFr: "Cheniselle (Sandy)", type1: "bug", type2: "ground", power: 2 },
  { id: 10005, nameFr: "Cheniselle (Trash)", type1: "bug", type2: "steel", power: 2 },
  { id: 10006, nameFr: "Shaymin (Sky)", type1: "grass", type2: "flying", power: 5 },
  { id: 10007, nameFr: "Giratina (Origin)", type1: "ghost", type2: "dragon", power: 5 },
  { id: 10008, nameFr: "Motisma (Heat)", type1: "electric", type2: "fire", power: 3 },
  { id: 10009, nameFr: "Motisma (Wash)", type1: "electric", type2: "water", power: 3 },
  { id: 10010, nameFr: "Motisma (Frost)", type1: "electric", type2: "ice", power: 3 },
  { id: 10011, nameFr: "Motisma (Fan)", type1: "electric", type2: "flying", power: 3 },
  { id: 10012, nameFr: "Motisma (Mow)", type1: "electric", type2: "grass", power: 3 },
  { id: 10013, nameFr: "Morphéo (Sunny)", type1: "fire", power: 1 },
  { id: 10014, nameFr: "Morphéo (Rainy)", type1: "water", power: 1 },
  { id: 10015, nameFr: "Morphéo (Snowy)", type1: "ice", power: 1 },
  { id: 10016, nameFr: "Bargantua (Blue Striped)", type1: "water", power: 2 },
  { id: 10017, nameFr: "Darumacho (Zen)", type1: "fire", type2: "psychic", power: 2 },
  { id: 10018, nameFr: "Meloetta (Pirouette)", type1: "normal", type2: "fighting", power: 5 },
  { id: 10019, nameFr: "Boréas (Therian)", type1: "flying", power: 5 },
  { id: 10020, nameFr: "Fulguris (Therian)", type1: "electric", type2: "flying", power: 5 },
  { id: 10021, nameFr: "Démétéros (Therian)", type1: "ground", type2: "flying", power: 5 },
  { id: 10022, nameFr: "Kyurem (Black)", type1: "dragon", type2: "ice", power: 5 },
  { id: 10023, nameFr: "Kyurem (White)", type1: "dragon", type2: "ice", power: 5 },
  { id: 10024, nameFr: "Keldeo (Resolute)", type1: "water", type2: "fighting", power: 5 },
  { id: 10025, nameFr: "Mistigrix (Female)", type1: "psychic", power: 2 },
  { id: 10026, nameFr: "Exagide (Blade)", type1: "steel", type2: "ghost", power: 3 },
  { id: 10027, nameFr: "Pitrouille (Small)", type1: "ghost", type2: "grass", power: 1 },
  { id: 10028, nameFr: "Pitrouille (Large)", type1: "ghost", type2: "grass", power: 1 },
  { id: 10029, nameFr: "Pitrouille (Super)", type1: "ghost", type2: "grass", power: 1 },
  { id: 10030, nameFr: "Banshitrouye (Small)", type1: "ghost", type2: "grass", power: 3 },
  { id: 10031, nameFr: "Banshitrouye (Large)", type1: "ghost", type2: "grass", power: 3 },
  { id: 10032, nameFr: "Banshitrouye (Super)", type1: "ghost", type2: "grass", power: 3 },
  { id: 10061, nameFr: "Floette (Eternal)", type1: "fairy", power: 2 },
  { id: 10086, nameFr: "Hoopa (Unbound)", type1: "psychic", type2: "dark", power: 5 },
  { id: 10091, nameFr: "Rattata (Alola)", type1: "dark", type2: "normal", power: 1 },
  { id: 10092, nameFr: "Rattatac (Alola)", type1: "dark", type2: "normal", power: 2 },
  { id: 10100, nameFr: "Raichu (Alola)", type1: "electric", type2: "psychic", power: 3 },
  { id: 10101, nameFr: "Sabelette (Alola)", type1: "ice", type2: "steel", power: 1 },
  { id: 10102, nameFr: "Sablaireau (Alola)", type1: "ice", type2: "steel", power: 2 },
  { id: 10103, nameFr: "Goupix (Alola)", type1: "ice", power: 1 },
  { id: 10104, nameFr: "Feunard (Alola)", type1: "ice", type2: "fairy", power: 3 },
  { id: 10105, nameFr: "Taupiqueur (Alola)", type1: "ground", type2: "steel", power: 1 },
  { id: 10106, nameFr: "Triopikeur (Alola)", type1: "ground", type2: "steel", power: 2 },
  { id: 10107, nameFr: "Miaouss (Alola)", type1: "dark", power: 1 },
  { id: 10108, nameFr: "Persian (Alola)", type1: "dark", power: 2 },
  { id: 10109, nameFr: "Racaillou (Alola)", type1: "rock", type2: "electric", power: 1 },
  { id: 10110, nameFr: "Gravalanch (Alola)", type1: "rock", type2: "electric", power: 2 },
  { id: 10111, nameFr: "Grolem (Alola)", type1: "rock", type2: "electric", power: 3 },
  { id: 10112, nameFr: "Tadmorv (Alola)", type1: "poison", type2: "dark", power: 1 },
  { id: 10113, nameFr: "Grotadmorv (Alola)", type1: "poison", type2: "dark", power: 3 },
  { id: 10114, nameFr: "Noadkoko (Alola)", type1: "grass", type2: "dragon", power: 3 },
  { id: 10115, nameFr: "Ossatueur (Alola)", type1: "fire", type2: "ghost", power: 2 },
  { id: 10118, nameFr: "Zygarde (10 Power Construct)", type1: "dragon", type2: "ground", power: 5 },
  { id: 10119, nameFr: "Zygarde (50 Power Construct)", type1: "dragon", type2: "ground", power: 5 },
  { id: 10120, nameFr: "Zygarde (Complete)", type1: "dragon", type2: "ground", power: 5 },
  { id: 10123, nameFr: "Plumeline (Pom Pom)", type1: "electric", type2: "flying", power: 2 },
  { id: 10124, nameFr: "Plumeline (Pau)", type1: "psychic", type2: "flying", power: 2 },
  { id: 10125, nameFr: "Plumeline (Sensu)", type1: "ghost", type2: "flying", power: 2 },
  { id: 10126, nameFr: "Lougaroc (Midnight)", type1: "rock", power: 2 },
  { id: 10127, nameFr: "Froussardine (School)", type1: "water", power: 1 },
  { id: 10130, nameFr: "Météno (Orange Meteor)", type1: "rock", type2: "flying", power: 3 },
  { id: 10131, nameFr: "Météno (Yellow Meteor)", type1: "rock", type2: "flying", power: 3 },
  { id: 10132, nameFr: "Météno (Green Meteor)", type1: "rock", type2: "flying", power: 3 },
  { id: 10133, nameFr: "Météno (Blue Meteor)", type1: "rock", type2: "flying", power: 3 },
  { id: 10134, nameFr: "Météno (Indigo Meteor)", type1: "rock", type2: "flying", power: 3 },
  { id: 10135, nameFr: "Météno (Violet Meteor)", type1: "rock", type2: "flying", power: 3 },
  { id: 10136, nameFr: "Météno (Red)", type1: "rock", type2: "flying", power: 3 },
  { id: 10137, nameFr: "Météno (Orange)", type1: "rock", type2: "flying", power: 3 },
  { id: 10138, nameFr: "Météno (Yellow)", type1: "rock", type2: "flying", power: 3 },
  { id: 10139, nameFr: "Météno (Green)", type1: "rock", type2: "flying", power: 3 },
  { id: 10140, nameFr: "Météno (Blue)", type1: "rock", type2: "flying", power: 3 },
  { id: 10141, nameFr: "Météno (Indigo)", type1: "rock", type2: "flying", power: 3 },
  { id: 10142, nameFr: "Météno (Violet)", type1: "rock", type2: "flying", power: 3 },
  { id: 10147, nameFr: "Magearna (Original)", type1: "steel", type2: "fairy", power: 5 },
  { id: 10152, nameFr: "Lougaroc (Dusk)", type1: "rock", power: 2 },
  { id: 10155, nameFr: "Necrozma (Dusk Mane)", type1: "psychic", type2: "steel", power: 5 },
  { id: 10156, nameFr: "Necrozma (Dawn Wings)", type1: "psychic", type2: "ghost", power: 5 },
  { id: 10157, nameFr: "Necrozma (Ultra)", type1: "psychic", type2: "dragon", power: 5 },
  { id: 10161, nameFr: "Miaouss (Galar)", type1: "steel", power: 1 },
  { id: 10162, nameFr: "Ponyta (Galar)", type1: "psychic", power: 2 },
  { id: 10163, nameFr: "Galopa (Galar)", type1: "psychic", type2: "fairy", power: 3 },
  { id: 10164, nameFr: "Ramoloss (Galar)", type1: "psychic", power: 1 },
  { id: 10165, nameFr: "Flagadoss (Galar)", type1: "poison", type2: "psychic", power: 3 },
  { id: 10166, nameFr: "Canarticho (Galar)", type1: "fighting", power: 2 },
  { id: 10167, nameFr: "Smogogo (Galar)", type1: "poison", type2: "fairy", power: 3 },
  { id: 10168, nameFr: "M. Mime (Galar)", type1: "ice", type2: "psychic", power: 2 },
  { id: 10169, nameFr: "Artikodin (Galar)", type1: "psychic", type2: "flying", power: 5 },
  { id: 10170, nameFr: "Électhor (Galar)", type1: "fighting", type2: "flying", power: 5 },
  { id: 10171, nameFr: "Sulfura (Galar)", type1: "dark", type2: "flying", power: 5 },
  { id: 10172, nameFr: "Roigada (Galar)", type1: "poison", type2: "psychic", power: 3 },
  { id: 10173, nameFr: "Corayon (Galar)", type1: "ghost", power: 2 },
  { id: 10174, nameFr: "Zigzaton (Galar)", type1: "dark", type2: "normal", power: 1 },
  { id: 10175, nameFr: "Linéon (Galar)", type1: "dark", type2: "normal", power: 2 },
  { id: 10176, nameFr: "Darumarond (Galar)", type1: "ice", power: 1 },
  { id: 10177, nameFr: "Darumacho (Galar Standard)", type1: "ice", power: 2 },
  { id: 10178, nameFr: "Darumacho (Galar Zen)", type1: "ice", type2: "fire", power: 2 },
  { id: 10179, nameFr: "Tutafeh (Galar)", type1: "ground", type2: "ghost", power: 1 },
  { id: 10180, nameFr: "Limonde (Galar)", type1: "ground", type2: "steel", power: 2 },
  { id: 10181, nameFr: "Zygarde (10)", type1: "dragon", type2: "ground", power: 5 },
  { id: 10184, nameFr: "Salarsen (Low Key)", type1: "electric", type2: "poison", power: 3 },
  { id: 10185, nameFr: "Bekaglaçon (Noice)", type1: "ice", power: 2 },
  { id: 10186, nameFr: "Wimessir (Female)", type1: "psychic", type2: "normal", power: 2 },
  { id: 10187, nameFr: "Morpeko (Hangry)", type1: "electric", type2: "dark", power: 2 },
  { id: 10188, nameFr: "Zacian (Crowned)", type1: "fairy", type2: "steel", power: 5 },
  { id: 10189, nameFr: "Zamazenta (Crowned)", type1: "fighting", type2: "steel", power: 5 },
  { id: 10191, nameFr: "Shifours (Rapid Strike)", type1: "fighting", type2: "water", power: 5 },
  { id: 10192, nameFr: "Zarude (Dada)", type1: "dark", type2: "grass", power: 5 },
  { id: 10193, nameFr: "Sylveroy (Ice)", type1: "psychic", type2: "ice", power: 5 },
  { id: 10194, nameFr: "Sylveroy (Shadow)", type1: "psychic", type2: "ghost", power: 5 },
  { id: 10229, nameFr: "Caninos (Hisui)", type1: "fire", type2: "rock", power: 1 },
  { id: 10230, nameFr: "Arcanin (Hisui)", type1: "fire", type2: "rock", power: 3 },
  { id: 10231, nameFr: "Voltorbe (Hisui)", type1: "electric", type2: "grass", power: 1 },
  { id: 10232, nameFr: "Électrode (Hisui)", type1: "electric", type2: "grass", power: 3 },
  { id: 10233, nameFr: "Typhlosion (Hisui)", type1: "fire", type2: "ghost", power: 3 },
  { id: 10234, nameFr: "Qwilfish (Hisui)", type1: "dark", type2: "poison", power: 2 },
  { id: 10235, nameFr: "Farfuret (Hisui)", type1: "fighting", type2: "poison", power: 2 },
  { id: 10236, nameFr: "Clamiral (Hisui)", type1: "water", type2: "dark", power: 3 },
  { id: 10237, nameFr: "Fragilady (Hisui)", type1: "grass", type2: "fighting", power: 2 },
  { id: 10238, nameFr: "Zorua (Hisui)", type1: "normal", type2: "ghost", power: 1 },
  { id: 10239, nameFr: "Zoroark (Hisui)", type1: "normal", type2: "ghost", power: 3 },
  { id: 10240, nameFr: "Gueriaigle (Hisui)", type1: "psychic", type2: "flying", power: 3 },
  { id: 10241, nameFr: "Colimucus (Hisui)", type1: "steel", type2: "dragon", power: 2 },
  { id: 10242, nameFr: "Muplodocus (Hisui)", type1: "steel", type2: "dragon", power: 4 },
  { id: 10243, nameFr: "Séracrawl (Hisui)", type1: "ice", type2: "rock", power: 3 },
  { id: 10244, nameFr: "Archéduc (Hisui)", type1: "grass", type2: "fighting", power: 3 },
  { id: 10245, nameFr: "Dialga (Origin)", type1: "steel", type2: "dragon", power: 5 },
  { id: 10246, nameFr: "Palkia (Origin)", type1: "water", type2: "dragon", power: 5 },
  { id: 10247, nameFr: "Bargantua (White Striped)", type1: "water", power: 2 },
  { id: 10248, nameFr: "Paragruel (Female)", type1: "water", type2: "ghost", power: 3 },
  { id: 10249, nameFr: "Amovénus (Therian)", type1: "fairy", type2: "flying", power: 4 },
  { id: 10250, nameFr: "Tauros (Paldea Combat Breed)", type1: "fighting", power: 3 },
  { id: 10251, nameFr: "Tauros (Paldea Blaze Breed)", type1: "fighting", type2: "fire", power: 3 },
  { id: 10252, nameFr: "Tauros (Paldea Aqua Breed)", type1: "fighting", type2: "water", power: 3 },
  { id: 10253, nameFr: "Axoloto (Paldea)", type1: "poison", type2: "ground", power: 1 },
  { id: 10254, nameFr: "Fragroin (Female)", type1: "normal", power: 3 },
  { id: 10255, nameFr: "Deusolourdo (Three Segment)", type1: "normal", power: 3 },
  { id: 10256, nameFr: "Superdofin (Héroïque)", type1: "water", power: 2 },
  { id: 10257, nameFr: "Famignol (Family Of Three)", type1: "normal", power: 2 },
  { id: 10258, nameFr: "Nigirigon (Droopy)", type1: "dragon", type2: "water", power: 2 },
  { id: 10259, nameFr: "Nigirigon (Stretchy)", type1: "dragon", type2: "water", power: 2 },
  { id: 10260, nameFr: "Tapatoès (Blue Plumage)", type1: "normal", type2: "flying", power: 2 },
  { id: 10261, nameFr: "Tapatoès (Yellow Plumage)", type1: "normal", type2: "flying", power: 2 },
  { id: 10262, nameFr: "Tapatoès (White Plumage)", type1: "normal", type2: "flying", power: 2 },
  { id: 10272, nameFr: "Ursaking (Bloodmoon)", type1: "ground", type2: "normal", power: 3 },
  { id: 10273, nameFr: "Ogerpon (Wellspring Mask)", type1: "grass", type2: "water", power: 5 },
  { id: 10274, nameFr: "Ogerpon (Hearthflame Mask)", type1: "grass", type2: "fire", power: 5 },
  { id: 10275, nameFr: "Ogerpon (Cornerstone Mask)", type1: "grass", type2: "rock", power: 5 },
  { id: 10276, nameFr: "Terapagos (Terastal)", type1: "normal", power: 5 },
  { id: 10277, nameFr: "Terapagos (Stellar)", type1: "normal", power: 5 },
] as const;
